// =====================================================================
// COMPONENT: abiomed-chat.component.ts
// FUNCTIONAL OVERVIEW:
//   Provides the chat and summarizer experience, including streamed text,
//   image responses, file uploads, history, feedback, and source viewing.
// DEPENDENCIES: ChatService, InteractionService, Angular Material dialogs
// ROUTE: Chat routes configured by the application routing module
// =====================================================================
import { AfterViewChecked, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, Optional, Inject, Input } from '@angular/core';
import { ResponseModel, ChatWithBot, choice, usage, Message, SystemPrompt, DocumentEntry } from '../../model/rolePlay.model';
import { ActivatedRoute, Router } from '@angular/router';
import { async, firstValueFrom, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatService } from '../../service/chat-service';
import { DatePipe } from '@angular/common';
import {
  AiChatLLMRequest, CreateChatReqRes, SendChatResponse, ChatDetailsResponse,
  DownloadFileRequest, CreateFeedbackMetadatRequest, UpdateFeedbackMetadataRequest
} from '../../model/chat.model';
import { isFileUplaodEnabled, TRENDING_TOPIC_ABIOCHAT } from '../../utility/constant';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ChatDetails, RefreshHistory } from '../../model/interaction.model';
import { ToastrService } from 'ngx-toastr';
import { LikeDislikeDialogComponent } from '../like-dislike-dialog/like-dislike-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BUSINESS_FAQ_ROLE, CHAT_DISABLED_BUSINESS_UNITS, ConstantConfig, DEFAULT_PLATFORM_LABEL, DOCUMENT_NUMBER, errorPhrases, PLAYGROUND_B_ENABLED_ROLES, PLAYGROUND_ENABLED_ROLES, refDocHideForRoleLabel, searchString, MAX_FILE_SIZE_BYTES } from '../../utility/constant-config';
import { AbiochatReferenceDialogComponent } from '../abiochat-reference-dialog/abiochat-reference-dialog.component';
import { SecureDocViewerDialogComponent, SecureDocViewerData, SecureDocMediaType } from '../secure-doc-viewer-dialog/secure-doc-viewer-dialog.component';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
import html2pdf from 'html2pdf.js';
import { marked } from 'marked';
import { TraineeListService } from '../../service/trainee-list.service';
import { KeyVaultService } from '../../service/key-vault.service';
import { environment } from '../../../environments/environment';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { DocumentExpiryComponent } from '../document-expiry/document-expiry.component';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NewAuthService } from '../../service/refreshToken/new-auth.service';
import { ConsoleLoggingListener } from 'microsoft-cognitiveservices-speech-sdk/distrib/lib/src/common.browser/ConsoleLoggingListener';
import { PlatformRegionService } from '../../../app/service/shared/platform-region.service'
import { ChatRegionMarketService } from '../../v2/modules/roleplay/services/chat-region-market.service';
import { SurveyConfigurationService } from '../../v2/services/admin/survey-configuration/survey-configuration.service';
import { SurveyPopupComponent, SurveyPopupDialogData } from '../../v2/modules/admin/global-configuration/components/survey-popup/survey-popup.component';
import { UserService } from '../../service/shared/user-service.service';
import { FeedbackService } from '../../service/feedback.service';
interface ResponseType {
  error?: string;
}
interface UploadStep {
  title: string;
  message: string;
  status: 'pending' | 'in-progress' | 'done' | 'error';
  timestamp?: number;
}
interface StreamProgressStep {
  step: string;
  status: string;
  detail: string;
  processing_time_sec?: number;
}

interface StreamImageItem {
  path: string;
  src: string;
  description?: string;
  loading?: boolean;
  /** JHUD-5267: source reference document the image was extracted from. */
  fileName?: string;
  pageNumber?: number;
  /** JHUD-5781: whether the image belongs to the internal (true) or external (false) response. */
  isInternal?: boolean;
}

interface PersistedImageItem {
  image_path: string;
  image_desc: string;
  /** JHUD-5267: source reference document persisted with the chat history payload. */
  filename?: string;
  page_number?: number;
}

interface StreamImageEntry {
  path: string;
  description?: string;
  fileName?: string;
  pageNumber?: number;
}

interface StreamResponseSection {
  answer: string;
  documents: any[];
  disDocument: any[];
  chunkContent: any[];
  showDoc: boolean;
  showAll: boolean;
  images: StreamImageItem[];
  showAllImages: boolean;
}

@Component({
    selector: 'app-abiomed-chat',
    templateUrl: './abiomed-chat.component.html',
    styleUrl: './abiomed-chat.component.scss',
    providers: [DatePipe],
    standalone: false
})
export class AbioMedChatComponent implements OnInit, OnDestroy, AfterViewChecked {
  private readonly destroy$ = new Subject<void>();
  applyClass: boolean;
  chatConversation: ChatWithBot[] = [];
  firstTimeSummarizer: boolean = true;
  frmStt: boolean = false;
  test_version: boolean = false;
  systemPrompt: SystemPrompt;
  streamingResponseOn: boolean = false;
  chatConversationIndex: number = 0;
  chatConversationLastResponseIndex: number = 0;
  chatConversationLastUserRequest: string = "";
  response: ResponseModel;
  config: any = ConstantConfig;
  choices: choice[] = [];
  modelUsage: usage;
  promptText: any;
  promptText1 = '';
  bContainer: string = '';
  docArr: Array<any> = [];
  showSpinner: boolean = false;
  historyLoading: boolean = false;
  nextVal: any = 0;
  isRolePlay: boolean = false;
  isAbioMedChat: boolean = false;
  showSidebar: boolean = true;
  showOverlayContent: boolean = false;
  isStart: boolean = false;
  streamSubscription: any = new Subscription();
  summarizerQandASubscription: any = new Subscription();
  date: any;
  apimUrl: string;
  userId: number;
  chunks: Blob[] = [];
  noDocumetToDisplay: number;
  headerDisclaimer: string;
  isLoading: boolean = false;
  selectedFile: File | null = null;
  selectedFileUrl: string | null = null;
  isFileUplaodEnabled: boolean;
  private _uploadStreamSub: Subscription | null = null;
  public uploadSteps: UploadStep[] = [];
  public showUploadLoader = false;
  public currentStep: { title: string; message: string } | null = null;
  private incomingQueue: Array<{ title: string; message: string }> = [];
  private processingQueue = false;
  private displayDelay = 600;
  icons: any = [{ name: 'avatar', url: '../../../assets/images/JJMT_Icon_Web_Profile.png' },
  { name: 'chatbot', url: '../../../assets/images/chatbot-icon.svg' },
  { name: 'like', url: '../../../assets/images/tabler_thumb-up.svg' },
  { name: 'dislike', url: '../../../assets/images/tabler_thumb-down.svg' },
  { name: 'regenerate', url: '../../../assets/images/tabler_refresh.svg' },
  { name: 'filledLike', url: '../../../assets/images/filled_thumb-up.svg' },
  { name: 'filledDislike', url: '../../../assets/images/filled_thumb-down.svg' },
  { name: 'foundationModel', url: '../../../assets/images/foundation_model_icon.svg' },
  { name: 'showpadIcon', url: '../../../assets/images/showpad_icon.svg' }
  ]
  switch: string = 'T';
  color: string = '#fff';
  trendingTopicFilterName: string = TRENDING_TOPIC_ABIOCHAT;
  trendingTopicsList: any = [];
  chatDetailsResponse: Array<ChatDetailsResponse> = [];
  creatChatSubscription: any = new Subscription();
  summaraizerSubscription: any = new Subscription();
  sendChatResponseSubscription: Subscription;
  trendingTopicsSubscription: Subscription;
  chatDetailsBySessionId: Subscription;
  dataObject: any = {
    chat_session_id: 1
  }


  createSessionFirstTimeFlag: boolean = true;
  newChat: boolean = false;
  subscription: any;
  abioFocusText: string;
  abioFocusApiText: string;
  dataSourceArr: Array<string> = [];
  chatStatus: string = 'NC';
  chatOverlayContentText: string;
  showChatFocusContent: boolean = false;
  public isRegenerated: boolean = false;
  public isPublicKnowledge: boolean = false;
  private previousScrollHeight: number;
  // showChatFocusContent: boolean = true;
  //test_version: boolean = true;
  showAllDocs: boolean = false;
  test_version1: boolean = false;
  @ViewChild('textarea') textareaRef: ElementRef<HTMLTextAreaElement>;
  @ViewChild('scrollContainer') private readonly scrollContainer: ElementRef;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  hideOverlayContent: boolean = false;
  givenName: string = "";
  showOverlayContentheading: boolean = false;
  showChatFocusContentHeading: boolean = false;
  getConversationFeedback = [];
  promptType: string = 'Chat';
  docArrHistory = [];
  userRole: string;
  previousContent = ''; // Keep track of previously received content
  buffer = ''; // Keep track of previously received content
  mute: boolean = true;
  personMapping: { [key: string]: string } = {
    'fieldRep': 'AI',
    'CS': 'User'
  };
  textToSpeechEnabled = true;
  textToSpeechEnabledSubscription!: Subscription;
  CustomizeDetailsSubscription!: Subscription;
  private loadHistoryDetailsSubscription: Subscription;
  mic: boolean = false;
  global_mute: boolean = false;
  stopWriting: boolean = false;
  moduleIdentifier: string = '';
  datasource: any = [];
  customizationDetails: any;
  pdfClientSubscription: Subscription;
  roleName: string;
  smClass: boolean;
  chunk: string;
  summarizerPage: boolean;
  chatPage: boolean = true;
  scrollbarObserver: any
  requestStartTime: Date;
  responseTime: Date;
  welcomeMessage: string = 'Welcome to Chat. How may I help you?';
  welcomeMessageJPN: string = 'HCPが関わるHCC関連のみ回答可能です'
  bunitCode: string;
  isChatDisabled: boolean = false;
  isFeedback = false;
  isPlayGround = false;
  isPlayGroundB = false;
  showArr: Array<any> = [];
  playgroundRoles = PLAYGROUND_ENABLED_ROLES;
  playgroundBRoles = PLAYGROUND_B_ENABLED_ROLES;
  businessFaqRoles = BUSINESS_FAQ_ROLE;
  repeatCount: number = 0;
  isRepeat: boolean = false;
  headerUrl: any;
  comment: string;
  defaultExpiryDate: Date;
  isRegenerating: boolean = false;
  refreshTimer?: any;
  query: string[] = []
  isHistoryOn: boolean = false;
  previousHistoryId: number;
  isDragOver = false;
  selectedFileHtml: any;
  smallDevice: boolean = false;
  selectedFileName: string = '';
  storeFile: File;
  isSupplementaryQuestionEnabled: boolean;
  enableResponseSplit: boolean = false;
  externalAfterInternal: boolean = false;
  // SSE stream progress tracking
  streamProgressSteps: StreamProgressStep[] = [];
  showStreamProgress: boolean = false;
  waitingForResponse: boolean = false;
  sseStreamSubscription: Subscription;
  @Input() isDialogMode: boolean = false;
  @Input() chatSessionId: string = '';
  @Input() feedbackId: number = 0;
  @Input() highlightUserQuery: string = '';
  @Input() historyFrom: string = '';
  highlightStyle: string = '';
  isUserAllowed: boolean = false;
  isStatusBarAllowed: boolean = false;
  isPrimaryMarketEnabled: boolean = false;
  configFlag: boolean = false;
  isShowpad: boolean = false;
  show_showpad_url: boolean = false;
  supportedFileExtensions: string[] = [];
  readonly maxInlineImages = 4;
  private streamImageObjectUrls: string[] = [];

  get fileInputAccept(): string {
    return this.supportedFileExtensions.map((ext) => `.${ext.toLowerCase()}`).join(',');
  }

  get isITAdmin(): boolean {
    const role = (this.roleName || sessionStorage.getItem('role') || '').toUpperCase();
    return role === 'SUPERVISOR';
  }

  constructor(private readonly route: ActivatedRoute, public TraineeService: TraineeListService, public ChatService: ChatService, private readonly intService: InteractionService,
    private readonly dialog: MatDialog, private readonly tts: TextToSpeechService, public router: Router, private readonly toastr: ToastrService,
    private readonly datePipe: DatePipe, private readonly traineeService: TraineeListService,
    private readonly keyVaultService: KeyVaultService, private readonly newAuthService: NewAuthService, private PlatformRegionService: PlatformRegionService,
    private chatRegionMarketService: ChatRegionMarketService,
    private readonly userService: UserService,
    private readonly surveyConfigurationService: SurveyConfigurationService, private feedbackService: FeedbackService,
    @Optional() private dialogRef: MatDialogRef<AbioMedChatComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any) {
    this.intService.refreshHeader$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.tts.stopAudio();
      this.mic = false;
    });
    this.intService.regenerate$.pipe(takeUntil(this.destroy$)).subscribe(({ additionalInfo }) => {
      this.regenerate(additionalInfo);
    });
    if (this.dialogData) {
      this.isDialogMode = true;
    }
  }


  getSystemConfiguration() {
    this.CustomizeDetailsSubscription = this.traineeService.getCustomizeDetails().subscribe(config => {
      this.datasource = config;
      this.textToSpeechEnabled = config.enable_voice_interaction;
      this.headerDisclaimer = this.addLineBreakBeforeSpan(config?.header_message);
      this.headerUrl = config?.header_url
      this.isFileUplaodEnabled = config?.chat_doc_upload;
      this.supportedFileExtensions = this.parseSupportedFileExtensions(config?.supported_file_extensions);
      this.isSupplementaryQuestionEnabled = config?.llm_subsequent_ques;
      this.enableResponseSplit = config?.enable_response_split ?? false;
      this.externalAfterInternal = config?.external_after_internal ?? false;
      this.isUserAllowed = config?.show_chat_cost_info;
      this.isStatusBarAllowed = config?.show_chat_status_bar;
      this.configFlag = config?.show_source_url;
      this.show_showpad_url = config?.show_showpad_url;
      this.intService.labelSubject.next(config.product_custom_label);
      if (config.idle_minutes && config.idle_minutes > 0) {
        sessionStorage.setItem("idle_minutes", config.idle_minutes);
        this.traineeService.sessionTimeout$.next(true);
      }
    }, error => {
      this.intService.labelSubject.next(DEFAULT_PLATFORM_LABEL);
    })
  }

  private parseSupportedFileExtensions(rawValue: any): string[] {
    if (Array.isArray(rawValue)) {
      const normalized = rawValue
        .map((item) => String(item || '').replace(/^[.\s]+/, '').trim().toUpperCase())
        .filter(Boolean);
      return normalized;
    }

    if (typeof rawValue === 'string' && rawValue.trim() !== '') {
      let parsedArray: any[] | null = null;
      try {
        parsedArray = JSON.parse(rawValue.replace(/'/g, '"'));
      } catch {
        parsedArray = rawValue.split(',').map((item) => item.trim());
      }

      if (Array.isArray(parsedArray)) {
        const normalized = parsedArray
          .map((item) => String(item || '').replace(/^[.\s]+/, '').trim().toUpperCase())
          .filter(Boolean);
        return normalized;
      }
    }

    return [];
  }

  private isFileExtensionSupported(fileName: string): boolean {
    if (!this.supportedFileExtensions.length) {
      this.toastr.error('Supported file extensions are not configured. Please contact support.');
      return false;
    }
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return false;
    }
    const extension = fileName.slice(dotIndex + 1).trim().toUpperCase();
    return this.supportedFileExtensions.includes(extension);
  }

  // JHUD-5268: only image uploads (JPEG/JPG/PNG) should carry the typed user_request in the upload payload
  private isImageFile(fileName: string): boolean {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return false;
    }
    const extension = fileName.slice(dotIndex + 1).trim().toUpperCase();
    return ['JPEG', 'JPG', 'PNG'].includes(extension);
  }

  ngOnInit() {
    this.registerSubscriptions();
    this.loadDependecies();
    this.checkSurveyPopup();
    this.intService.isProductSelected.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.loadDependecies();
        this.streamSubscription.unsubscribe();
        if (this.sseStreamSubscription) this.sseStreamSubscription.unsubscribe();
        this.summaraizerSubscription.unsubscribe();
        this.streamingResponseOn = false;
        this.showStreamProgress = false;
        this.waitingForResponse = false;
        this.stopWritingClick();
      }
    });
    // this.router.navigate(['/admin/skills/list'], { skipLocationChange: true });
  }

  private checkSurveyPopup(): void {
    const wwid = Number(sessionStorage.getItem('userId'));
    const bu = this.PlatformRegionService.selected_platform_code || '';
    const region = this.PlatformRegionService.selected_region_code || '';

    if (!wwid || !bu || !region || !this.userService.isTraineeUser()) return;

    this.surveyConfigurationService.getPopupStatus(wwid, bu, region).subscribe({
      next: (status) => {
        if (!status?.show_popup) return;
        this.dialog.open(SurveyPopupComponent, {
          panelClass: 'survey-popup-dialog',
          disableClose: true,
          data: {
            wwid,
            survey_id: status.survey_id,
            survey_link: status.survey_link || '',
            remind_buttons_visible: status.remind_buttons_visible ?? true
          } as SurveyPopupDialogData
        });
      }
    });
  }

  loadDependecies() {
    this.promptText = '';
    this.roleName = sessionStorage.getItem("role");
    sessionStorage.setItem("sessionId", "0");
    this.setRole();
    this.noDocumetToDisplay = DOCUMENT_NUMBER;

    this.getSystemConfiguration();
    this.clearSelectedFileInput();
    this.intService.fetchData().subscribe();
    this.showOverlayContent = true;
    this.showOverlayContentheading = true;
    this.userId = Number(sessionStorage.getItem('userId'));
    this.givenName = sessionStorage.getItem("givenName");
    this.bunitCode = sessionStorage.getItem('businessUnitCode');
    this.isChatDisabled = CHAT_DISABLED_BUSINESS_UNITS.includes(this.bunitCode);
    this.isPrimaryMarketEnabled = this.PlatformRegionService.selectedProductPlatform?.is_primary_market_enabled || false;
    this.chatRegionMarketService.initialize();
    this.setFocus();
    this.datasourceCode();
    this.keyVaultService.apimUrl$.pipe(takeUntil(this.destroy$)).subscribe(url => this.apimUrl = url);

    // New Chat Actions - start
    let chatType: string;
    let id: string;
    let historyFrom: string;

    if (this.chatSessionId && this.isDialogMode) {
      chatType = 'CD';
      id = this.chatSessionId;
      historyFrom = this.historyFrom || 'feedback';
      if (this.feedbackId) {
        sessionStorage.setItem('feedbackId', this.feedbackId.toString());
      }
      if (this.highlightUserQuery) {
        this.highlightStyle = 'red-background';
      }
    } else if (this.isDialogMode && this.dialogData) {
      chatType = this.dialogData.chat || '';
      id = this.dialogData.id?.toString() || '';
      historyFrom = this.dialogData.historyFrom || '';
      if (this.dialogData.feedbackId) {
        sessionStorage.setItem('feedbackId', this.dialogData.feedbackId.toString());
      }
      if (this.dialogData.highlightUserQuery) {
        this.highlightUserQuery = this.dialogData.highlightUserQuery;
        this.highlightStyle = this.dialogData.highlightStyle || 'red-background';
      }
    } else {
      chatType = this.route.snapshot.queryParamMap.get('chat');
      id = this.route.snapshot.queryParamMap.get('id');
      historyFrom = this.route.snapshot.queryParamMap.get('historyFrom');
    }
    this.isFeedback = historyFrom === 'feedback' ? true : false;
    if (chatType !== "" && chatType !== null && chatType !== undefined) {
      this.chatStatus = chatType;
      if (chatType === 'CD') {
        this.getChatDetailsBySessionId(parseInt(id), 'CHAT');
        this.dataObject.chat_session_id = parseInt(id);
        this.createSessionFirstTimeFlag = false;
      }
    }
    if (this.chatStatus === 'NC') {
      this.newChat = true;
      this.test_version = false;
      this.welcomeMessage = 'Welcome to Chat. How may I help you?'
      this.showOverlayContent = true;
      if (window.innerWidth <= 768) {
        this.applyClass = true;
      }
      this.showOverlayContentheading = true;
      this.setContent();
      this.setFocus();
    } else if (this.chatStatus === 'SM') {
      this.query = []
      this.showChatFocusContent = true;
      this.showOverlayContent = false;
      this.showOverlayContentheading = false;
      if (window.innerWidth <= 768) {
        this.applyClass = true;
      }
      this.showChatFocusContentHeading = true;
      this.setContent();
      this.newChat = true;
      this.setFocus();
      this.getTrendingTopics();
    }
    // End

    this.reset();
    this.summaraizerSubscription?.unsubscribe();
    this.summaraizerSubscription = this.ChatService.summarizerDocExpDate$.subscribe((res: any) => {
      if (res) {
        this.summarizeFile(res.event, res.expiryDate);
      }
    })
  }

  /** Called once from ngOnInit only - re-registering these duplicates every downstream API call. */
  private registerSubscriptions() {
    this.loadHistoryDetailsSubscription = this.intService.loadHistorydetailsObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        this.setFocus();
        if (value.chat === 'CHAT' || value.chat === 'SUMMARIZER') {
          this.getChatDetailsBySessionId(value.id, value.chat);
          this.dataObject.chat_session_id = value.id;
          this.createSessionFirstTimeFlag = false;
          this.firstTimeSummarizer = false;
        }
      });

    this.subscription = this.intService.chatstatus
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: ChatDetails) => {
        this.isFeedback = false;
        if ((this.moduleIdentifier !== value.chat_identifier) && this.streamSubscription) {
          this.streamingResponseOn = false;
          this.showSpinner = false;
          this.stopWriting = false;
          this.showStreamProgress = false;
          this.waitingForResponse = false;
          this.streamSubscription.unsubscribe();
          if (this.sseStreamSubscription) this.sseStreamSubscription.unsubscribe();
        }
        this.moduleIdentifier = value.chat_identifier;
        this.newChat = true;
        this.createSessionFirstTimeFlag = true;
        this.summarizerPage = false;
        this.chatPage = true;

        switch (value.chat_identifier) {
          case 'newchat':
            this.chatStatus = 'NC';
            this.test_version = false;
            this.streamSubscription.unsubscribe();
            if (this.sseStreamSubscription) this.sseStreamSubscription.unsubscribe();
            this.summaraizerSubscription.unsubscribe();
            this.streamingResponseOn = false;
            this.showSpinner = false;
            this.stopWriting = false;
            this.showStreamProgress = false;
            this.waitingForResponse = false;
            this.chatPage = true;
            this.roleName = sessionStorage.getItem("role");
            this.setContent();
            this.setFocus();
            this.getTrendingTopics();
            this.welcomeMessage = 'Welcome to Chat. How may I help you?'
            break;
          case 'summarizer':
            this.chatStatus = 'SM';
            this.streamSubscription.unsubscribe();
            if (this.sseStreamSubscription) this.sseStreamSubscription.unsubscribe();
            this.streamingResponseOn = false;
            this.showStreamProgress = false;
            this.waitingForResponse = false;
            this.firstTimeSummarizer = true;
            this.showSpinner = false;
            this.stopWriting = false;
            this.chatPage = false;
            this.setContent();
            this.setFocus();
            this.getTrendingTopics();
            this.showOverlayContent = false;
            this.summarizerPage = true;
            if (this.datasource.summarizer_disclaimer && this.chatStatus === 'SM') {
              this.smClass = true;
            }

            break;
          case 'chatDetails':
            this.chatStatus = 'CD';
            this.setContent(value.chat_session_id);
            break;
          default:
            this.chatStatus = 'NC';
            this.test_version = false;
            this.setContent();
            this.setFocus();
            break;
        }
      });
  }
  ngAfterViewChecked(): void {
    if (this.scrollContainer.nativeElement.scrollHeight !== this.previousScrollHeight) {
      this.previousScrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    }
  }
  setFocus() {
    if (this.textareaRef && !(window.innerWidth <= 1080)) {
      this.textareaRef.nativeElement.focus();
    }
  }
  datasourceCode() {
    this.dataSourceArr = [];
    let business_unit_code = sessionStorage.getItem('businessUnitCode');
    if (business_unit_code !== "") {
      this.ChatService.datasourceCode(business_unit_code).subscribe(
        (res) => {
          if (res && res.length > 0) {
            res.map(item => {
              this.dataSourceArr.push(item.data_source);
            });
          } else {
            this.dataSourceArr = [];
          }
        });
    }
  }
  MuteAudio(value) {
    this.mute = value;
    if (this.mute) {
      this.tts.stopAudio();
    }
  }
  getMessageWithLink(message: string, url: string): string {
    if (!message || !url) return "";
    const parts = message.split('<a>');
    if (parts.length > 1) {
      const beforeLink = parts[0];
      const afterLink = parts[2].split('</a>')[0];
      const linkText = parts[1].split('</a>')[0];
      const linkedPart = `<a href="${url}" target="_blank" class="redirect-link">${linkText}</a>`;
      return beforeLink + linkedPart + afterLink;
    } else {
      return message;
    }
  }
  scrollToBottom(): void {
    const container = this.scrollContainer.nativeElement;
    container.scroll({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  }
  onEnter() {
    this.hideOverlayContent = true; // Set to true when Enter is pressed to hide the overlay content
  }
  openSourceLink(id: string | number | null | undefined) {
    const payload = {
      "metadata_id": String(id)
    };
    this.feedbackService.sourceDocLink(payload).subscribe((data) => {
      const sourceLink = data?.source_url;
      if (data?.error_code === 'not_found') {
        this.toastr.error('Valid Source path is not found');
        return;
      } else if (sourceLink === null || sourceLink === undefined || sourceLink === '') {
        this.toastr.error('Valid Source path is not found');
        return;
      }

      if (sourceLink) {
        window.open(sourceLink, '_blank', 'noopener,noreferrer');
      }
    }, (error) => {
      this.toastr.error('Valid Source path is not found');
    });
  }
  setRole() {
    let ROLE: string = sessionStorage.getItem('role');
    if (ROLE === 'TRAINER' || ROLE === 'SUPERVISOR') {
      this.userRole = 'Trainer';
    } else {
      this.userRole = 'Trainee';
    }
  }
  handleContent(content: string) {
    this.mute = false;
    this.mic = true;
    // this.global_mute = true;
    this.frmStt = true;
    this.promptText = content;
    this.checkTextResponse()
  }
  setContent(chatSessionId?: number) {

    const promptName = {
      NC: 'Chat',
      SM: 'summarizer'
    }
    this.promptType = promptName[this.chatStatus] || 'Chat';
    this.resetConversation();
    this.clearSelectedFileInput();
    /* if (this.promptText?.trim() === '') {
      return;
    } */
    this.showOverlayContent = false;
    this.showChatFocusContent = true;
    this.applyClass = false;
    this.smClass = false;
    this.showOverlayContentheading = false;
    this.showChatFocusContentHeading = true;
    if (this.chatStatus === 'SM') {
      this.abioFocusText = this.abioFocusApiText = 'Summarizer';
      this.chatOverlayContentText = 'Welcome to Summarizer, I can help you to summarize the document.';
    }
    else if (this.chatStatus === 'NC') {
      this.abioFocusText = this.abioFocusApiText = '';
      this.roleName = sessionStorage.getItem("role");
      this.showOverlayContent = true;
      this.showChatFocusContent = false;
      this.showOverlayContentheading = true;
      this.showChatFocusContentHeading = false;
      this.setFocus();
    }
    else if (this.chatStatus === 'CD') {
      this.abioFocusText = this.abioFocusApiText = '';
      this.showOverlayContent = false;
      this.showOverlayContentheading = false;
      this.showChatFocusContentHeading = false;
      this.showChatFocusContent = false;
      this.getChatDetailsBySessionId(chatSessionId, this.abioFocusText);
    }
    else {
      this.chatOverlayContentText = "";
    }
    const chat_type = this.promptType; // Example chat_type, replace with your actual logic to get chat_type
    // this.intService.getSystemPrompt(chat_type).subscribe((data: SystemPrompt) => {
    //   this.systemPrompt = data[0];
    // });
  }

  resetConversation() {
    this.promptText = '';
    this.chatConversation = [];
    this.clearSelectedFileInput();
  }
  reset() {
    this.promptText = '';
    this.chatConversation = [];
    this.showSpinner = false;
    this.clearSelectedFileInput();
    if (this.showOverlayContent) {
      this.getTrendingTopics();
    }
    this.createSessionFirstTimeFlag = true;
  }
  onFileSelected(event: Event) {
    const f = (event.target as HTMLInputElement).files?.[0] ?? null;
    if (!f) return;

    this.selectFileForPrompt(f);
  }

  onPaste(event: ClipboardEvent): void {
    if (!this.isFileUplaodEnabled || this.isFeedback) {
      return;
    }

    const clipboardData = event.clipboardData;
    if (!clipboardData) {
      return;
    }

    const clipboardFile = this.extractSupportedFileFromClipboard(clipboardData);
    if (!clipboardFile) {
      return;
    }

    event.preventDefault();
    this.selectFileForPrompt(clipboardFile);
  }

  private extractSupportedFileFromClipboard(clipboardData: DataTransfer): File | null {
    if (!this.supportedFileExtensions.length) {
      return null;
    }

    const candidateFiles: File[] = [];
    const items = clipboardData.items || [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind !== 'file') {
        continue;
      }
      const file = item.getAsFile();
      if (file) {
        candidateFiles.push(file);
      }
    }

    const files = clipboardData.files || [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file) {
        candidateFiles.push(file);
      }
    }

    for (let i = 0; i < candidateFiles.length; i++) {
      const normalizedFile = this.ensureClipboardFileHasSupportedName(candidateFiles[i]);
      if (!normalizedFile?.name) {
        continue;
      }
      if (this.hasSupportedExtension(normalizedFile.name)) {
        return normalizedFile;
      }
    }

    return null;
  }

  private hasSupportedExtension(fileName: string): boolean {
    const extension = this.extractFileExtension(fileName);
    return !!extension && this.supportedFileExtensions.includes(extension);
  }

  private extractFileExtension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return '';
    }
    return fileName.slice(dotIndex + 1).trim().toUpperCase();
  }

  private ensureClipboardFileHasSupportedName(file: File): File {
    if (file.name && file.name.includes('.')) {
      return file;
    }

    const extension = this.getExtensionFromMimeType(file.type);
    if (!extension || !this.supportedFileExtensions.includes(extension.toUpperCase())) {
      return file;
    }

    const generatedName = `pasted-file-${Date.now()}.${extension}`;
    return new File([file], generatedName, { type: file.type || `application/${extension}` });
  }

  private getExtensionFromMimeType(mimeType: string): string {
    const normalized = (mimeType || '').toLowerCase();
    const mimeToExtension: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'application/json': 'json',
      'text/plain': 'txt',
      'text/csv': 'csv',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'image/gif': 'gif',
      'image/webp': 'webp',
      'image/bmp': 'bmp',
      'audio/mpeg': 'mp3',
      'audio/mp3': 'mp3',
      'audio/wav': 'wav',
      'audio/x-wav': 'wav',
      'audio/mp4': 'm4a',
      'audio/aac': 'aac',
      'audio/ogg': 'ogg',
      'video/mp4': 'mp4',
      'video/quicktime': 'mov',
      'video/x-matroska': 'mkv',
      'video/webm': 'webm'
    };

    return mimeToExtension[normalized] || '';
  }

  private selectFileForPrompt(file: File): void {
    if (!this.isFileExtensionSupported(file.name)) {
      this.toastr.error("This file format can't be uploaded.");
      return;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      this.toastr.error('Selected file size more than 20MB');
      return;
    }

    this.selectedFile = file;
    this.selectedFileHtml = this.generateFileHtml(file);
    this.selectedFileName = this.truncateName(file.name);

    setTimeout(() => this.textareaRef?.nativeElement?.focus(), 10);
  }

  async openDocumentExpiry(file: any, event: any) {
    this.isLoading = true;
    try {
      const value = await this.checkTokenCount(event);
      this.isLoading = false; // <-- stop the loader before opening the dialog

      const dialogRef = this.dialog.open(DocumentExpiryComponent, {
        width: '600px',
        height: '340px',
        data: { file, event, value, popup: true },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    } catch (error) {
      this.isLoading = false;
      let message = 'We could not process the file. Please re-upload the document.'
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { message: message, okOnly: true }
      });
      console.error('Error fetching token count:', error);
    }
  }

  showConfirmationDialog(message: string, File, event): Promise<boolean> {

    this.defaultExpiryDate = new Date();
    this.defaultExpiryDate.setDate(this.defaultExpiryDate.getDate() + 7);
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { message: message }
      });

      dialogRef.afterClosed().subscribe(result => {
        const userResponse = result === true ? 'Yes' : 'No';
        const request = {
          chat_user_id: this.userId,
          business_unit_code: sessionStorage.getItem('businessUnitCode'),
          chat_session_id: this.dataObject.chat_session_id,
          user_response: userResponse,
          expiry_date: this.getFormattedDate(this.defaultExpiryDate)
        };
        if (result === false) {
          const selectedFile = event.srcElement?.files[0];
          this.ChatService.summarizeBackground(selectedFile, request).subscribe({
            next: (res) => {
              this.toastr.info(res.message);
            },
            error: () => {
              this.toastr.error('Error processing request');
            }
          });
        }
        const value = { popup: true }
        if (result === true) {
          this.dialog.open(DocumentExpiryComponent, {
            width: '600px',
            height: '340px',
            data: { file: File, event: event, result: result, id: this.dataObject.chat_session_id, value: value },
            disableClose: true
          });
        }
        resolve(result === 'true');
      });
    });
  }
  checkTokenCount(event: Event): void {
    const tokenRequest = {
      chat_user_id: this.userId,
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
    };
    const file = (event.target as HTMLInputElement)?.files?.[0] ?? (event as any).srcElement?.files?.[0];
    if (!file) return;

    this.isLoading = true;
    this.ChatService.getTokenCount(file, tokenRequest).subscribe({
      next: (res: any) => {
        this.isLoading = false;

        const proceedWithInsert = () => {
          // keep a blob URL for preview/download
          if (this.selectedFileUrl) {
            URL.revokeObjectURL(this.selectedFileUrl);
            this.selectedFileUrl = null;
          }
          this.selectedFile = file;
          this.selectedFileUrl = URL.createObjectURL(file);

          // Insert a short instruction above the file token + file token at start
          const preText = 'Please summarize the attached file and answer my question below:\n';
          const token = `[file:${file.name}] `;
          // remove any existing file token at start
          this.promptText = (this.promptText || '').replace(/^\[file:.*?\]\s*/, '');
          this.promptText = preText + token + (this.promptText || '');

          // focus textarea and set caret after the token so user can continue typing
          setTimeout(() => {
            try {
              const el = this.textareaRef?.nativeElement;
              el?.focus();
              el.setSelectionRange((preText + token).length, (preText + token).length);
            } catch (e) { /* ignore */ }
          }, 20);
        };

        if (res?.popup) {
          // show confirmation dialog (your existing method). If user confirms -> insert, else abort.
          this.showConfirmationDialog(
            'This file exceeds 50,000 tokens and will be processed in the background; you will receive an email upon completion, and a summary will be available in your history. Do you wish to proceed?',
            file,
            event
          ).then((userConfirmed: boolean) => {
            if (userConfirmed) {
              proceedWithInsert();
            } else {
              // user cancelled — keep UI unchanged or show toast if you want
              // e.g. this.toastr.info('Upload cancelled by user');
            }
          }).catch(() => {
            // dialog error — do nothing or log
          });
        } else {
          // normal path — immediately insert file token + text
          proceedWithInsert();
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Token count failed', err);
        // optionally show toast: this.toastr.error('Failed to check token count');
      }
    });
  }

  summarizeFile(event: Event, selectedDate) {
    if (this.streamingResponseOn || this.showSpinner) {
      event.preventDefault();
      this.toastr.info('Please wait for the ongoing response before giving a new prompt.');
      return;
    }
    this.showChatFocusContent = false;
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const selectedFile = inputElement.files[0];
      // Request by user
      this.pushChatTextContent(selectedFile.name, 'CS', 'person');
      this.showSpinner = true;
      const requestTime = new Date();
      const request = {
        chat_session_id: this.dataObject.chat_session_id,
        chat_user_id: this.userId,
        expiry_date: selectedDate,
        business_unit_code: sessionStorage.getItem('businessUnitCode')
      };

      this.summaraizerSubscription = this.ChatService.summarizerFileUpload(selectedFile, request).subscribe({
        next: (res) => {
          if (res?.[0]?.hasOwnProperty("error_code")) {
            let responseArr: any = res;
            this.showSpinner = false;
            this.docArr = [];
            this.showArr = []
            this.toastr.error(responseArr[0].friendly_message);
            this.pushChatTextContent(responseArr[0].friendly_message, 'fieldRep', 'bot');
          } else if (res?.error?.some(err => err.includes(searchString))) {
            this.showSpinner = false;
            this.streamingResponseOn = false;
            this.stopWriting = false;
            if (this.global_mute) {
              this.mute = false;
            }
            this.newAuthService.handleSessionExpiry();
          } else if (res?.error) {
            this.showSpinner = false;
            this.toastr.error('Upload/Summarization is Failed...Please try again.', '', { positionClass: 'toast-top-right' });
            this.pushChatTextContent("Error: " + res.error[0], 'fieldRep', 'bot');
          } else if (res?.statusCode) {
            this.showSpinner = false;
            this.pushChatTextContent(res.message, 'fieldRep', 'bot');
            this.toastr.error(res.message, '', { positionClass: 'toast-top-right' });
          } else {
            this.showSpinner = false;
            this.streamingResponseOn = false;
            this.stopWriting = false;
            if (this.global_mute) {
              this.mute = false;
            }
            if (this.textToSpeechEnabled && !this.mute) {
              this.tts.speak(res.summary);
            }
            this.pushChatTextContent(res.summary, 'fieldRep', 'bot', '', 0, [], [], false, 'FILESUMMARY');

          }
          // For like and dislike actions
          setTimeout(() => {
            this.chatConversation[this.chatConversation.length - 1]["chat_conversation_id"] = res.id;
            this.chatConversation[this.chatConversation.length - 1]["likedislike"] = "Empty";
            // this.chatConversation[this.chatConversation.length - 1]["regenerate"] = "show";
          });
        }, complete: () => {
          this.scrollbarObserver.disconnect();
          this.refreshHistory();
          const responseTime = new Date();

          if (this.mic) {
            setTimeout(() => {
              this.mute = true;
            }, 1000);
          }
          this.chatConversationLastResponseIndex = this.chatConversation.length - 1;
          if (this.docArr.length > 0)
            this.chatConversation[this.chatConversationLastResponseIndex].showDoc = true;
          // this.saveChatResponse(requestTime, responseTime, false, selectedFile.name);
        },
        error: (err) => {
          this.showSpinner = false;
          this.toastr.error('Upload/Summarization is Failed...Please try again.', '', { positionClass: 'toast-top-right' });
        }
      });
    }
  }
  encodeFolderStructure(url) {
    if (url === null) {
      return;
    }
    const folders = url.split(/[\/|]/);;
    const encodedFolders = folders.map(folder => encodeURIComponent(folder));
    const encodedUrl = encodedFolders.join('/');
    return encodedUrl;
  }

  getActualIndex(chatArrIndex: number, chunkContentIndex: number): number {
    const chatValues = this.chatConversation?.[chatArrIndex];
    if (!chatValues) {
      return chunkContentIndex;
    }

    const tempDocObj = chatValues.disDocument?.[chunkContentIndex];
    if (!tempDocObj) {
      return chunkContentIndex;
    }

    const tempDocName = tempDocObj.doc_name ?? '';
    let tempPageNo: number | undefined;
    if (Array.isArray(tempDocObj.page_numbers) && tempDocObj.page_numbers.length > 0) {
      tempPageNo = Number(tempDocObj.page_numbers[0]);
    } else if (typeof tempDocObj.page_numbers === 'number') {
      tempPageNo = tempDocObj.page_numbers;
    } else if (typeof tempDocObj.page_numbers === 'string' && tempDocObj.page_numbers.trim() !== '') {
      const n = Number(tempDocObj.page_numbers);
      tempPageNo = Number.isFinite(n) ? n : undefined;
    } else {
      tempPageNo = undefined;
    }

    const docIndex = (chatValues.documents ?? []).findIndex(obj => {
      if (!obj) return false;
      const docNameMatches = obj.doc_name === tempDocName;
      if (!docNameMatches) return false;
      if (tempPageNo == null) return true; // match by name only if no page provided
      const objPage = Array.isArray(obj.page_numbers) ? obj.page_numbers[0] : obj.page_numbers;
      return Number(objPage) === Number(tempPageNo);
    });

    if (docIndex === -1) {
      // If no mapping found, return the original index to avoid further errors
      return chunkContentIndex;
    }

    return docIndex;
  }

  private decodeExternalUrl(url: string): string {
    if (!url) return '';
    try {
      return decodeURIComponent(url);
    } catch {
      return url;
    }
  }

  downloadFile(chatArrIndex: number, chunkContentIndex: number, chatStatus: string, pageNumber?: number, event?: MouseEvent, start?: string, end?: string, showpadDocUrl?: string) {
    event?.stopPropagation?.();
    event?.preventDefault?.();
    this.tts.resetAudio();
    if (this.pdfClientSubscription) this.pdfClientSubscription.unsubscribe();
    var externalShowpadUrl = '';
    if (showpadDocUrl){
      externalShowpadUrl = this.decodeExternalUrl((showpadDocUrl || '').trim());
      sessionStorage.setItem('showpad_doc_url', 'true');
    } else {
      sessionStorage.removeItem('showpad_doc_url');
    }
    this.isShowpad = sessionStorage.getItem('is_showpad_user') === 'true' || false;
    if (externalShowpadUrl && this.isShowpad) {
      // this.openSecureDocViewer(externalShowpadUrl, pageNumber, 'Showpad Document', true);
      window.open(externalShowpadUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    chunkContentIndex = this.getActualIndex(chatArrIndex, chunkContentIndex);
    let chatValues = this.chatConversation[chatArrIndex];

    // Track reference document click
    const chunkIdArr = chatValues.chunkContent?.[chunkContentIndex]?.chunk_id;
    const chunkId = Array.isArray(chunkIdArr) ? chunkIdArr.join(',') : (chunkIdArr ?? '');
    const chatHistoryId = chatValues.chat_conversation_id;
    if (chunkId && chatHistoryId) {
      this.ChatService.trackReferenceClick({ chunk_id: chunkId, chat_history_id: chatHistoryId }).subscribe({
        error: (err) => console.error('Error tracking reference click', err)
      });
    }

    let docName = encodeURIComponent(this.replaceExtensionWithPdf(chatValues.chunkContent[chunkContentIndex].file_name || chatValues.chunkContent[chunkContentIndex].doc_name));
    let location = chatValues.chunkContent[chunkContentIndex].location;

    this.openBlobDocument(docName, location, pageNumber, start, end);
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Resolves a blob-hosted reference document (uploaded or business-unit
  //   storage) and opens it in the secure viewer at the requested page.
  //
  // MODIFICATION HISTORY (latest first - keep ONLY the last 3):
  //   [JHUD-5267] 2026-09-30 11:20 | Venkatesan | Extracted from downloadFile so image references can reuse it.
  // -----------------------------------------------------------------
  /**
   * Opens a blob-stored document in the secure document viewer.
   * @param docName URL-encoded file name (already normalised to a PDF extension where applicable).
   * @param location Blob folder structure the document lives under.
   * @param pageNo Page to open the document at.
   * @param start Optional media start offset.
   * @param end Optional media end offset.
   */
  private openBlobDocument(docName: string, location: string, pageNo?: number, start?: string, end?: string): void {
    if (!docName) {
      this.showSpinner = false;
      this.toastr.error('An error occurred while extracting the document... Please try again.', '', { positionClass: 'toast-top-right' });
      return;
    }

    const locationUrl = (location?.trim() !== '' && location != null) ? `${this.encodeFolderStructure(location)}/${docName}` : `${docName}`;
    const mimeType = this.getDocumentType(docName);
    const JWT_token = localStorage.getItem('bearer_token');

    if (location === 'uploaded_doc') {
      const docUrl = `${this.apimUrl}/ai-advisor-storage/getblobmetadata?blobContainer=summary-docs&fileNameWithExtension=${docName}&Authorization=${JWT_token}`;
      this.handleDocUrl(docUrl, mimeType, start, end, pageNo, docName);
    } else {
      const isVideo = this.isVideoFileName(docName) || (mimeType?.startsWith('video/') ?? false);
      const isAudio = this.isAudioFileName(docName) || (mimeType?.startsWith('audio/') ?? false);
      this.ChatService.getBusinessUnitByCode(sessionStorage.getItem('businessUnitCode')).subscribe(
        resp => {
          const docUrl = `${this.apimUrl}/${resp.blob_storage_name}/getblobmetadata?business_unit_code=${sessionStorage.getItem('businessUnitCode')}&wwid=${sessionStorage.getItem('userId')}&blobContainer=medtech&fileNameWithExtension=${resp.blob_folder_name}/${locationUrl}&Authorization=${JWT_token}`;
          if (isVideo) {
            this.openVideoInViewer(docUrl, start, end, docName);
            this.showSpinner = false;
          } else if (isAudio) {
            this.openAudioInViewer(docUrl, start, end, docName);
            this.showSpinner = false;
          } else {
            this.retrievePdf(docUrl, pageNo, mimeType, docName);
          }
        },
        err => {
          this.showSpinner = false;
          this.toastr.error('An error occurred while extracting the document... Please try again.', '', { positionClass: 'toast-top-right' });
        }
      );
    }
  }

  private handleDocUrl(docUrl: string, mimeType: string | null, start?: string, end?: string, pageNo?: number, fileName?: string) {
    const isVideo = this.isVideoFileName(fileName) || (mimeType?.startsWith('video/') ?? false);
    const isAudio = this.isAudioFileName(fileName) || (mimeType?.startsWith('audio/') ?? false);
    if (isVideo) {
      this.openVideoInViewer(docUrl, start, end, fileName);
      this.showSpinner = false;
    } else if (isAudio) {
      this.openAudioInViewer(docUrl, start, end, fileName);
      this.showSpinner = false;
    } else {
      this.retrievePdf(docUrl, pageNo, mimeType, fileName);
    }
  }

  private parseTimeToSeconds(t?: string): number | undefined {
    if (!t) return undefined;
    const s = String(t).trim();
    if (/^\d+(\.\d+)?$/.test(s)) return Number(s);
    const parts = s.split(':').map(p => Number(p));
    if (parts.some(Number.isNaN)) return undefined;
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    return undefined;
  }
  private async resolvePlayableUrl(encodedUrl: string): Promise<string> {
    const safeUrl = (encodedUrl || '').trim();
    if (/getblobmetadata/i.test(safeUrl)) {
      try {
        const resp = await fetch(safeUrl, { credentials: 'include' });
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const json = await resp.json();
        return (json?.file_url || json?.signedUrl || json?.blobUrl || json?.url || json?.mediaUrl) ?? safeUrl;
      } catch {
        return safeUrl;
      }
    }
    return safeUrl;
  }
  isMedia(element: any): boolean {
    const name = (element?.doc_name ?? '').toLowerCase();
    const mime = (element?.mime_type ?? '').toLowerCase();
    const byExt = /\.(mp3|mp4|mkv|webm|wav|m4a|mov)$/i.test(name);
    const byMime = mime.startsWith('audio/') || mime.startsWith('video/');
    return byExt || byMime;
  }
  isPdf(element: any): boolean {
    const rawName = (element?.doc_name ?? '').toLowerCase().trim();
    const mime = (element?.mime_type ?? '').toLowerCase().trim();

    if (/\.pdf$/i.test(rawName) || mime === 'application/pdf') return true;

    const baseName = rawName.split(/[?#]/)[0];
    const extMatch = baseName.match(/\.([a-z0-9]+)$/i);
    const ext = extMatch ? extMatch[1] : '';
    const mediaExts = ['mp3', 'mp4', 'mkv', 'mov'];
    if (!ext) return true;
    return !mediaExts.includes(ext);
  }


  private isVideoFileName(fileName: string | undefined): boolean {
    if (!fileName) return false;
    const ext = fileName.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
    return ['mp4', 'mp2', 'mkv', 'mov'].includes(ext);
  }

  private isAudioFileName(fileName: string | undefined): boolean {
    if (!fileName) return false;
    const ext = fileName.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
    return ['mp3', 'wav', 'm4a', 'aac', 'ogg'].includes(ext);
  }

  private isImageFileName(fileName: string | undefined): boolean {
    if (!fileName) return false;
    const ext = fileName.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg'].includes(ext);
  }

  private async openVideoInViewer(encodedUrl: string, start?: string, end?: string, title?: string): Promise<void> {
    let mediaUrl: string;
    try {
      mediaUrl = await this.resolvePlayableUrl(encodedUrl);
    } catch {
      this.toastr.error('An error occurred while loading the video... Please try again.', '', { positionClass: 'toast-top-right' });
      return;
    }

    this.dialog.open(SecureDocViewerDialogComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'secure-doc-viewer-panel',
      autoFocus: false,
      disableClose: false,
      data: {
        docUrl: mediaUrl,
        title: title || 'Video Viewer',
        mediaType: 'video',
        startTime: this.parseTimeToSeconds(start),
        endTime: this.parseTimeToSeconds(end)
      } as SecureDocViewerData
    });
  }

  private async openAudioInViewer(encodedUrl: string, start?: string, end?: string, title?: string): Promise<void> {
    let mediaUrl: string;
    try {
      mediaUrl = await this.resolvePlayableUrl(encodedUrl);
    } catch {
      this.toastr.error('An error occurred while loading the audio... Please try again.', '', { positionClass: 'toast-top-right' });
      return;
    }

    this.dialog.open(SecureDocViewerDialogComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'secure-doc-viewer-panel',
      autoFocus: false,
      disableClose: false,
      data: {
        docUrl: mediaUrl,
        title: title || 'Audio Viewer',
        mediaType: 'audio',
        startTime: this.parseTimeToSeconds(start),
        endTime: this.parseTimeToSeconds(end)
      } as SecureDocViewerData
    });
  }

  retrievePdf(docUrl, pageNo, mimeType, fileName?: string) {
    this.pdfClientSubscription = this.ChatService.getPdfReport(docUrl, mimeType).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      this.showSpinner = false;
      const isImage = this.isImageFileName(fileName) || (mimeType?.startsWith('image/') ?? false);
      this.openSecureDocViewer(fileURL, pageNo, fileName, false, isImage ? 'image' : 'pdf');
    },
      (err) => {
        this.showSpinner = false;
        this.toastr.error('An error occurred while extracting the document... Please try again.', '', { positionClass: 'toast-top-right' });
      });
  }

  openSecureDocViewer(
    docUrl: string,
    pageNumber?: number,
    title?: string,
    isExternalPage = false,
    mediaType?: SecureDocMediaType,
    enableImageCopyActions = false,
    enableImageZoomActions = false,
    imageDescription?: string
  ): void {
    this.dialog.open(SecureDocViewerDialogComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'secure-doc-viewer-panel',
      autoFocus: false,
      disableClose: false,
      data: {
        docUrl: docUrl,
        pageNumber: pageNumber || 1,
        title: title || 'Document Viewer',
        isExternalPage: isExternalPage,
        mediaType: mediaType ?? (isExternalPage ? 'external' : 'pdf'),
        enableImageCopyActions: enableImageCopyActions,
        enableImageZoomActions: enableImageZoomActions,
        imageDescription: imageDescription
      } as SecureDocViewerData
    });
  }
  replaceExtensionWithPdf(url: string): string {
    const extensions = ['.pptx', '.ppt', '.docx', '.doc', '.xlsx', '.xls', '.json', '.txt', '.jpg', '.jpeg', '.png'];
    const matchedExtension = extensions.find(ext => url.endsWith(ext));
    if (matchedExtension) {
      return url.replace(matchedExtension, '.pdf');
    }
    return url;
  }

  getDocumentType(docUrl: string) {
    const docTypeObj = { pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg' };
    let fileExt = this.getFileExtensionFromUrl(docUrl);
    return docTypeObj.hasOwnProperty(fileExt) ? docTypeObj[fileExt] : undefined;
  }

  getFileExtensionFromUrl(url: string): string {
    const filename = url.substring(url.lastIndexOf('/') + 1);
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return '';
    }
    return filename.substring(lastDotIndex + 1).toLowerCase();
  }


  displayTranscriptAsPdf() {
    if (this.chatConversation.length === 0) {
      this.toastr.info('No transcription is available to download.', '', { positionClass: 'toast-top-right' });
      return;
    }
    this.tts.resetAudio();
    const personMapping: { [key: string]: string } = {
      'fieldRep': 'AI',
      'CS': this.givenName
    };

    // Create the transcript HTML
    const transcriptHtml = this.chatConversation.map(chat => {
      const personLabel = personMapping[chat.person] || chat.person;
      const responseHtml = chat.person === 'fieldRep' ? marked.parse(chat.response) : chat.response;

      // Check if the response is from Public Knowledge
      const isFromPublicKnowledge = chat.foundationModel; // Adjust based on your chat object structure

      // Prepare the reference documents if available
      let referenceDocsHtml = '';
      if (chat.disDocument) {
        if (Array.isArray(chat.disDocument) && chat.disDocument.length > 0) {
          referenceDocsHtml = `
            <div class="reference-docs">
              <strong>Reference Documents:</strong>
              <ul>
                ${chat.disDocument.map(doc => `<li>${doc.doc_name.trim()}</li>`).join('')}
              </ul>
            </div>
          `;
        } else if (typeof chat.disDocument === 'string') {
          const docsArray = chat.disDocument.split(',').map(doc => doc.trim());
          if (docsArray.length > 0) {
            referenceDocsHtml = `
              <div class="reference-docs">
                <strong>Reference Documents:</strong>
                <ul>
                  ${docsArray.map(doc => `<li>${doc}</li>`).join('')}
                </ul>
              </div>
            `;
          }
        }
      }

      // Create the response HTML with Public Knowledge notice inline
      return `
        <div>
          <strong>${personLabel}:</strong> 
          ${isFromPublicKnowledge ? `<span class="fm-heading"><strong>Response from Public Knowledge</strong></span> ` : ''}
          ${responseHtml}
          ${referenceDocsHtml} 
        </div>
      `;
    }).join('');

    const htmlContent = `
      <div>
        <h1>Transcript</h1>
        ${transcriptHtml}
      </div>
    `;

    const options = {
      margin: [0.5, 0.5, 1.2, 0.5], // top, right, bottom, left
      filename: `chat_transcript_${this.dataObject.chat_session_id}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
        compress: true,
        autoFirstPage: true,
      },
      pagebreak: {
        mode: 'avoid-all',
        before: '.page-break',
      }
    };

    html2pdf().from(htmlContent).set(options).save();
  }





  getChatDetailsBySessionId(chatSessionId: number, chatType?: string) {
    if (window.innerWidth <= 768) {
      this.applyClass = true;
    }
    this.isHistoryOn = true;
    this.showChatFocusContent = false;
    this.showOverlayContent = false;
    this.chatConversation = [];
    this.historyLoading = true;
    this.clearSelectedFileInput();
    this.chatDetailsBySessionId = this.ChatService.getChatDetailsBySessionId(chatSessionId, chatType).subscribe({
      next: (data: ChatDetailsResponse[]) => {
        this.chatDetailsResponse = data;
        this.mapResponseToChatConversation();
        this.historyLoading = false;
        setTimeout(() => {
          let feedbackId = sessionStorage.getItem('feedbackId');
          if (feedbackId) {
            let specificDiv: any = document.getElementById('feedback-action-' + feedbackId);
            specificDiv?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });
          }
        }, 0);
        sessionStorage.setItem('region', (data.length > 0 && data[0].region_name) ? data[0].region_name : null);
        sessionStorage.setItem('market', (data.length > 0 && data[0].primary_market) ? data[0].primary_market : null);
        this.chatRegionMarketService.setSelectedMarketCode(data.length > 0 ? data[0].primary_market : null);
        sessionStorage.setItem('product', (data.length > 0 && data[0].product) ? data[0].product : null);
        sessionStorage.setItem('sessionId', (data.length > 0 && data[0].chat_session_id) ? data[0].chat_session_id.toString() : chatSessionId.toString());
      },
      error: (error) => {
        this.historyLoading = false;
        console.error('There was an error!', error);
      }
    });
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    return new Date(this.datePipe.transform(utcDateString.split('.')[0] + 'Z', 'yyyy-MM-dd HH:mm:ss'));
  }
  mapResponseToChatConversation() {
    if (Array.isArray(this.chatDetailsResponse) && this.chatDetailsResponse.length > 0) {
      this.chatConversation = [];
      this.chatDetailsResponse.forEach((item: ChatDetailsResponse) => {
        const questionDate = this.convertUtcToLocal(item.request_time);
        // Generate file HTML if file was uploaded - WITH DEBUG LOGGING
        let uploadedFileHtml = '';
        if (item.uploaded_doc_name && item.uploaded_doc_name.trim() !== '') {

          let cleanFileName = item.uploaded_doc_name;
          if (cleanFileName.includes('_')) {
            const parts = cleanFileName.split('_');
            if (!isNaN(Number(parts[0]))) {
              cleanFileName = parts.slice(1).join('_');
            }
          }

          uploadedFileHtml = this.generateFileHtml(cleanFileName);
        }

        let user_request: ChatWithBot = {
          person: 'CS',
          cssClass: 'person',
          response: item.user_request,
          timestamp: questionDate,
          id: item.id,
          first_name: item.first_name,
          userRequest: item.user_request,
          uploadedFileHtml: uploadedFileHtml
        };



        let chunkContent: Array<{
          end_time: string;
          start_time: string; score: any, location: string; doc_name: string; chunk_id: Array<string>; page_no: number; chunk_text: string, file_url: string, durations: any, showpad_doc_name?: string; showpad_doc_url?: string; document_id?: string | number | null
        }> = [];
        let localDocArr: Array<any> = [];
        let dispDocArr: Array<any> = [];

        if (item.chunk_content && item.chunk_content.trim() !== '[]') {
          try {
            chunkContent = JSON.parse(item.chunk_content).map(doc => this.normalizeChunkDoc(doc));
            chunkContent.forEach(doc => {
              localDocArr.push({
                score: doc.score,
                doc_name: `${doc.doc_name}`,
                chunkContent: doc.chunk_text,
                page_numbers: Array.isArray(doc.page_no) ? doc.page_no : [doc.page_no],
                durations: doc.durations,
                start_time: doc.start_time,
                end_time: doc.end_time,
                showpad_doc_name: doc.showpad_doc_name,
                showpad_doc_url: doc.showpad_doc_url,
                document_id: doc.document_id ?? (item as any).document_id ?? null,
              });
            });

            let newDocArr = this.processShowMoreDocs(chunkContent);
            newDocArr.forEach((entry) => {
              let score = entry.score;
              dispDocArr.push({
                score: score,
                doc_name: `${entry.doc_name}`,
                page_numbers: entry.pages,
                chunkContent: entry.chunk_text,
                durations: entry.durations,
                is_internal: entry.is_internal,
                showpad_doc_name: entry.showpad_doc_name,
                showpad_doc_url: entry.showpad_doc_url,
                document_id: entry.document_id,
              });
            });
          } catch (e) {
            console.error('Error parsing chunk_content JSON', e);
          }
        }

        const answerDate = this.convertUtcToLocal(item.response_time);
        let bot_answer: ChatWithBot;

        // Parse bot_response: handle {"internal":"...", "external":"..."} format from history
        let botResponseForDisplay = item.bot_response;
        let internalResponse = '';
        let externalResponse = '';
        let internalImages: PersistedImageItem[] = [];
        let externalImages: PersistedImageItem[] = [];
        try {
          const parsed = JSON.parse(item.bot_response);
          if (parsed && typeof parsed === 'object' && ('internal' in parsed || 'external' in parsed || 'internal_image' in parsed || 'external_image' in parsed)) {
            const storedInternal = item.internal_response ?? parsed.internal ?? '';
            const storedExternal = item.external_response ?? parsed.external ?? '';
            const parsedInternalImages = this.parsePersistedImageItems(parsed.internal_image);
            const parsedExternalImages = this.parsePersistedImageItems(parsed.external_image);

            internalImages = this.normalizePersistedImageItems(parsedInternalImages);
            externalImages = this.normalizePersistedImageItems(parsedExternalImages);

            // Read-time normalization based on current enable_response_split config
            if (this.enableResponseSplit) {
              internalResponse = storedInternal || '';
              externalResponse = storedExternal || '';
              botResponseForDisplay = this.getResponseInConfiguredOrder(internalResponse, externalResponse);
            } else {
              // When split is off: show internal (fallback to external if internal missing)
              internalResponse = storedInternal || storedExternal || '';
              botResponseForDisplay = internalResponse;
            }
          }
        } catch (e) {
          // Not JSON, use as-is (backward compatible)
        }

        const historyImages = [...internalImages, ...externalImages];
        let historySections: StreamResponseSection[];
        if (this.enableResponseSplit && (internalResponse || externalResponse || historyImages.length > 0)) {
          // JHUD-5781: keep internal images under internal content and external images under external content.
          const internalStreamImages = internalImages.map((entry) => this.toStreamImageItem(entry, true));
          const externalStreamImages = externalImages.map((entry) => this.toStreamImageItem(entry, false));
          historySections = this.buildSegregatedResponseSections(
            internalResponse,
            externalResponse,
            internalStreamImages,
            externalStreamImages,
            localDocArr,
            dispDocArr,
            chunkContent
          );
        } else {
          historySections = historyImages.length > 0
            ? [{
              answer: this.addLineBreakBeforeSpan(botResponseForDisplay),
              documents: localDocArr,
              disDocument: dispDocArr,
              chunkContent: chunkContent,
              showDoc: localDocArr.length > 0,
              showAll: false,
              images: historyImages.map((entry) => ({
                path: entry.image_path,
                src: this.buildStreamImageMetadataUrl(entry.image_path),
                description: entry.image_desc,
                loading: false,
                fileName: entry.filename,
                pageNumber: entry.page_number
              })),
              showAllImages: false
            }]
            : [];
        }

        if (item.type === 'summary' || item.type === 'summary qna') {
          bot_answer = {
            person: 'fieldRep',
            cssClass: 'bot',
            response: botResponseForDisplay,
            userRequest: item.user_request,
            timestamp: answerDate,
            chunkContent: chunkContent,
            showDoc: localDocArr.length > 0,
            showAll: false,
            documents: localDocArr,
            disDocument: dispDocArr,
            foundationModel: item.f_model_response,
            chat_conversation_id: (item.type === 'summary') ? item.doc_id : item.chat_id,
            likedislike: item.is_good === 1 ? 'like' : item.is_good === 0 ? 'dislike' : 'Empty',
            regenerate: 'show',
            summaryType: item.type,
            id: item.id,
            internalResponse: internalResponse,
            externalResponse: externalResponse,
            responseSections: historySections,
            internalImages: internalImages,
            externalImages: externalImages
          };
        } else {
          bot_answer = {
            person: 'fieldRep',
            cssClass: 'bot',
            response: botResponseForDisplay,
            userRequest: item.user_request,
            timestamp: answerDate,
            chunkContent: chunkContent,
            showDoc: localDocArr.length > 0,
            showAll: false,
            documents: localDocArr,
            disDocument: dispDocArr,
            foundationModel: item.f_model_response,
            chat_conversation_id: item.id,
            likedislike: item.is_good === 1 ? 'like' : item.is_good === 0 ? 'dislike' : 'Empty',
            regenerate: 'show',
            summaryType: item.type,
            id: item.id,
            internalResponse: internalResponse,
            externalResponse: externalResponse,
            responseSections: historySections,
            internalImages: internalImages,
            externalImages: externalImages
          };
        }

        this.chatConversation.push(user_request);
        this.chatConversation.push(bot_answer);
      });

    } else {
      console.warn('chatDetailsResponse is either not an array or is empty');
    }
  }

  @HostListener('window:resize')
  onResize() {
    const wasSmall = this.smallDevice;
    this.smallDevice = window.innerWidth <= 576;
    if (this.trendingTopicsList.length && wasSmall !== this.smallDevice) {
      this.getTrendingTopics();
    }
  }
  
  /**
   * Function to get the trending topics
   * @param chatType 
   */
  getTrendingTopics(chatType?: string) {
    const businessCode = sessionStorage.getItem('businessUnitCode');
    const region = this.chatRegionMarketService.selected_region_code || this.PlatformRegionService.selected_region_code;
    this.smallDevice = window.innerWidth <= 576;

    this.trendingTopicsSubscription?.unsubscribe();
    this.trendingTopicsSubscription = this.ChatService.trendingTopics(businessCode, region).subscribe({
      next: (data: any[]) => {
        const list = Array.isArray(data) ? data : [];
        this.trendingTopicsList = this.smallDevice ? list.slice(0, 3) : list;
      },
      error: (error) => {
        console.error('There was an error!', error);
      }
    });
  }
  getDisplayValue(item: any): string {
    return item?.faq ?? item?.topic_value ?? '';
  }

  onRegionMarketChanged(event: { region: string; market: string }): void {
    // The region/market selector re-emits its CURRENTLY active selection every
    // time it (re)initializes - e.g. every time this page is navigated to from
    // another module - not just on a genuine user-driven change. Treat it as a
    // no-op when it matches the platform's already-persisted region/market so
    // we don't trigger an unnecessary full chat reset + header reload, which
    // was destabilizing the header's role dropdown (JHUD-5257).
    const currentRegionCode = this.PlatformRegionService.selected_region_code || '';
    const currentMarketCode = this.PlatformRegionService.selected_market_code || '';
    if ((event.region || '') === currentRegionCode && (event.market || '') === currentMarketCode) {
      return;
    }

    this.PlatformRegionService.setDataForSelectedRegion(event.region);
    // Header caches the role dropdown per region/market, so force it to reload for the new selection.
    this.intService.triggerRefreshHeader('platformchange');
    this.streamSubscription?.unsubscribe();
    if (this.sseStreamSubscription) this.sseStreamSubscription.unsubscribe();
    this.summaraizerSubscription?.unsubscribe();
    this.streamingResponseOn = false;
    this.showStreamProgress = false;
    this.waitingForResponse = false;
    this.showSpinner = false;
    this.stopWriting = false;
    this.stopWritingClick();
    this.reset(); // already refreshes trending topics when the overlay is visible
    this.showOverlayContent = true
    this.refreshHistory();
    this.getSystemConfiguration();
  }

  openPage(docIndex: number, docItemIndex: number, pageNumber: number, event: MouseEvent, showpadDocUrl?: string): void {
    event.stopPropagation();
    this.downloadFile(docIndex, docItemIndex, this.chatStatus, pageNumber, undefined, undefined, undefined, showpadDocUrl);
  }


  menuHandler() {
    this.showSidebar = !this.showSidebar;
  }
  focusTextarea() {
    this.textareaRef.nativeElement.focus();
  }

  updateMessage(conversations, chat_conversation_id, likeDislikeVal) {
    let conversation = conversations.find(convo => convo.chat_conversation_id === chat_conversation_id);

    if (conversation) {
      this.toastr.success('Feedback submitted successfully.')
      conversation["likedislike"] = likeDislikeVal;
    } else {
      console.log("Conversation with the given ID not found.");
    }
  }
  copyToClipboard(chat: any): void {
    let responseText = chat.response;
    const isFromPublicKnowledge = chat.foundationModel;
    let referenceDocsText = '';
    let anchorElements = [];
    const div = document.createElement('div');
    div.className = 'reference_link_holder';
    let contentToCopy = ` ${responseText}\n`;
    const role_label = sessionStorage.getItem("displayRole");

    contentToCopy = this.cleanUpMarkdown(contentToCopy);
    if (isFromPublicKnowledge) {
      contentToCopy = `[Public Knowledge Response] ${contentToCopy}`;
    }

    for (let i = 0; i < chat.chunkContent.length; i++) {
      let docName = chat.chunkContent[i].doc_name;
      let location = chat.chunkContent[i].location;
      let pageNo = chat.chunkContent[i].page_no;

      if (docName !== undefined && docName !== null && docName !== '' && chat.chunkContent[i].is_reference !== 'N') {
        let docUrl = '';
        let JWT_token = localStorage.getItem('bearer_token');
        if (this.chatStatus == 'SM') {
          docUrl = `${this.apimUrl}/ai-advisor-storage/getblobmetadata?Authorization=${JWT_token}&blobContainer=summary-docs&fileNameWithExtension=${docName}#page=${pageNo}`;
        } else {
          if (sessionStorage.getItem('businessUnitCode') == 'EP') {
            docUrl = `${this.apimUrl}/ai-advisor-storage/getblobmetadata?Authorization=${JWT_token}&blobContainer=medtech&fileNameWithExtension=Electrophysiology/${location}/${docName}#page=${pageNo}`;
          } else if (sessionStorage.getItem('businessUnitCode') == 'TR') {
            docUrl = `${this.apimUrl}/trauma-storage/getblobmetadata?Authorization=${JWT_token}&blobContainer=medtech&fileNameWithExtension=trauma/${location}/${docName}#page=${pageNo}`;
          } else {
            docUrl = `${this.apimUrl}/velys-storage/getblobmetadata?Authorization=${JWT_token}&blobContainer=medtech&fileNameWithExtension=Velys/${location}/${docName}#page=${pageNo}`;
          }
        }
        const docLink = `
    <p><a href="${docUrl}">${docName}</a></p>`
        anchorElements.push(docLink);
      }

      if (chat.chunkContent.length === i + 1) {
        if (errorPhrases.some(phrase => chat.response.includes(phrase)) && refDocHideForRoleLabel.includes(sessionStorage.getItem("role"))) {
          anchorElements = [];
        }
        if ((anchorElements.length !== 0) && !(errorPhrases.some(phrase => chat.response.includes(phrase)) && refDocHideForRoleLabel.includes(sessionStorage.getItem("role")))) {
          contentToCopy += `<br> Reference Documents:<br> ${referenceDocsText}`;
        }
        this.copyTextToClipboard(contentToCopy, anchorElements);
      }
    }
    if (chat.chunkContent.length === 0) {
      this.copyTextToClipboard(contentToCopy, '');
    }
  }

  copyTextToClipboard(content: string, refArr: any): void {
    if (refArr) {
      refArr = refArr.join('\n')
    }
    const htmlContent = content + (refArr || '');
    // Create plain text version by stripping HTML tags
    const tempEl = document.createElement('div');
    tempEl.innerHTML = htmlContent;
    const plainText = tempEl.innerText || tempEl.textContent || '';

    if (navigator.clipboard && window.ClipboardItem) {
      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const textBlob = new Blob([plainText], { type: 'text/plain' });
      navigator.clipboard.write([
        new ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob })
      ]).then(() => {
        this.toastr.success('Content copied to clipboard!', '', { positionClass: 'toast-top-right' });
      }).catch(() => {
        this.fallbackCopy(htmlContent);
      });
    } else {
      this.fallbackCopy(htmlContent);
    }
  }

  private fallbackCopy(htmlContent: string): void {
    const temporaryDiv = document.createElement('div');
    temporaryDiv.innerHTML = htmlContent;
    document.body.appendChild(temporaryDiv);
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(temporaryDiv);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    document.body.removeChild(temporaryDiv);
    selection.removeAllRanges();
    this.toastr.success('Content copied to clipboard!', '', { positionClass: 'toast-top-right' });
  }
  cleanUpMarkdown(content: string): string {
    let cleanedContent = content;
    // Convert markdown headers (with optional leading whitespace) to bold
    cleanedContent = cleanedContent.replace(/^\s*#{1,6}\s+(.+)$/gm, '<b>$1</b>');
    // Convert bold markdown **text** to <b>text</b>
    cleanedContent = cleanedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    // Convert numbered list items to HTML list items
    cleanedContent = cleanedContent.replace(/^\s*\d+\.\s+(.+)$/gm, '<li>$1</li>');
    // Convert markdown bullet points to HTML list items
    cleanedContent = cleanedContent.replace(/^\s*[-*]\s+(.+)$/gm, '<li>$1</li>');
    // Wrap consecutive <li> items in <ul>
    cleanedContent = cleanedContent.replace(/((?:<li>.*?<\/li>\s*)+)/g, '<ul>$1</ul>');
    // Convert escaped newlines and actual newlines
    cleanedContent = cleanedContent.replace(/\\n/g, '\n');
    cleanedContent = cleanedContent.replace(/\n/g, '<br>');
    // Remove remaining markdown formatting characters
    cleanedContent = cleanedContent.replace(/[\*\_]{1,2}/g, '');
    return cleanedContent;
  }

  addLineBreakBeforeSpan(content: string | null | undefined): string {
    if (!content) {
      return '';
    }

    return content.replace(/(<span\b[^>]*>)/gi, '<br>$1');
  }

  likeDislikeClicked(data, chat_conversation_id, likedislike, summaryType) {
    const likeDislikeObj = {
      like: 1,
      dislike: 0
    };
    const likeDislikeVal = likeDislikeObj[data];
    const isFeedbackReadOnly = this.isFeedback;

    if (likedislike !== "Empty") {
      this.ChatService.getFeedbackMetadata(chat_conversation_id, summaryType).subscribe((res) => {
        const existingData = {
          selectedOption: res[0].feedback_id,
          comments: res[0].comment || ""
        };
        const editable = !isFeedbackReadOnly;
        const dialogRef = this.dialog.open(LikeDislikeDialogComponent, {
          width: '460px',
          // height: '390px',
          data: {
            dialogType: data,
            existingData: existingData,
            likedislike: likedislike,
            likeDislikeVal: likeDislikeVal,
            isEditable: editable,
            readOnly: isFeedbackReadOnly,
            chat_conversation_id: chat_conversation_id,
            summaryType: summaryType
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Call update message only if user submits

            this.updateMessage(this.chatConversation, chat_conversation_id, data);
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(LikeDislikeDialogComponent, {
        width: '460px',
        // height: '390px',
        data: {
          dialogType: data,
          likeDislikeVal: likeDislikeVal,
          isEditable: false,
          readOnly: isFeedbackReadOnly,
          chat_conversation_id: chat_conversation_id,
          summaryType: summaryType
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Call create feedback and update message only if user submits
          //this.createFeedbackMetadata(result, likeDislikeVal, chat_conversation_id, summaryType);
          this.updateMessage(this.chatConversation, chat_conversation_id, data);
        }
      });
    }
  }

  adjustHeight(event: Event) {
    const textarea = this.textareaRef.nativeElement;
    const overlayContent = document.querySelector('.overlay-content') as HTMLElement;
    textarea.style.height = '35px';
    const maxHeight = 120;
    textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
    if (textarea.scrollHeight > textarea.clientHeight) {
      textarea.classList.add('scrollable');
    } else {
      textarea.classList.remove('scrollable');
    }
    if (overlayContent) {
      const baseBottom = this.selectedFileHtml ? 73 : 40;
      const textareaHeight = Math.min(textarea.scrollHeight, maxHeight);
      const buffer = 10;
      const newBottom = baseBottom + textareaHeight + buffer;

      overlayContent.style.bottom = `${newBottom}px`;
    }
  }
  updateFeedbackData(chat_conversation_id, request, summarType) {
    this.ChatService.updateFeedbackMetadata(chat_conversation_id, request, summarType).
      subscribe((data: any[]) => {
      });
  }

  getFeedbackConversationData(chat_conversation_id, summaryType) {
    this.ChatService.getFeedbackMetadata(chat_conversation_id, summaryType).subscribe((res) => {
      this.getConversationFeedback = res;
    })
  }


  createFeedbackMetadata(result, val, chat_conversation_id, summaryType) { //document_summary_id
    let feedbackrequest: CreateFeedbackMetadatRequest;
    if (summaryType === 'TEXTSUMMARY' || summaryType === 'summary' || summaryType === 'FILESUMMARY') {
      feedbackrequest = {
        is_good: val,
        document_summary_id: chat_conversation_id,
        feedback_id: result.selectedOption,
        comment: result.additionalInfo || "",
        given_by: this.userId.toString(),
        business_unit_code: sessionStorage.getItem('businessUnitCode'),
      }
    } else {
      feedbackrequest = {
        is_good: val,
        chat_history_id: chat_conversation_id,
        feedback_id: result.selectedOption,
        comment: result.additionalInfo || "",
        given_by: this.userId.toString(),
        business_unit_code: sessionStorage.getItem('businessUnitCode'),
      }
    }

    this.ChatService.createFeedbackMetadata(feedbackrequest, summaryType).subscribe((res) => {
      if (val == 0) {
        this.toastr.info(res.message);

        if (res?.popup) {
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '500px',
            data: { message: 'Do you want to regenerate the response?' }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
              this.getTextResponse(this.chatConversation[0].userRequest, true, false, this.comment); // Call your method or logic
            }
          });
        }
      }
    });


  }



  pushChatContent(content: string, person: string, cssClass: string) {
    const currentTimeStamp = new Date();
    const chatToPush: ChatWithBot = { person: person, response: content, cssClass: cssClass, timestamp: currentTimeStamp };
    this.chatConversation.push(chatToPush);
  }
  regenerateResponse(startIndex) {
    this.isRegenerated = true;
    this.isPublicKnowledge = false;
    this.isPlayGround = false;
    this.isPlayGroundB = false;
    for (let index = startIndex; index >= 0; index--) {
      const message = this.chatConversation[index];
      if (message.person === 'CS') {
        this.promptText = message.response
        return;
      }
    }
  }
  subQuery(message) {
    if (message) {
      this.promptText = message
    }

  }
  regenerate(comment) {
    this.isPublicKnowledge = false;
    this.isRegenerated = true;
    this.isPlayGround = false;
    this.isPlayGroundB = false;
    this.getTextResponse(this.chatConversationLastUserRequest, true, false, comment, this.previousHistoryId);
  }
  foundationModel() {
    this.isPublicKnowledge = true;
    this.isRegenerated = false;
    this.isPlayGround = false;
    this.isPlayGroundB = false;
    this.getTextResponse(this.chatConversationLastUserRequest, false, true);
  }
  async regenerateToken() {
    if (this.isRegenerating) return;
    this.isRegenerating = true;
    try {
      const data = await this.newAuthService.getAccessToken(['user.read']);
      //this.toastr.success('New Access Token fetched successfully');
      localStorage.setItem('bearer_token', data);
    } catch (err) {
      console.log('Error fetching new access token:', err);
    } finally {
      this.isRegenerating = false;
      this.refreshTimer = setTimeout(() => this.regenerateToken(), 100);
    }
  }

  private uploadAndStreamResponse(uploadRequest: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.selectedFile) { resolve(); return; }
      this.showSpinner = false;
      // reset state
      this.incomingQueue = [];
      this.currentStep = { title: 'Upload', message: 'Starting upload...' };
      this.showUploadLoader = true;

      this._uploadStreamSub = this.ChatService.uploadFileStream(this.selectedFile, uploadRequest).subscribe({
        next: (chunk: string) => {
          if (!chunk) { return; }
          const trimmed = chunk.trim();
          if (!trimmed) { return; }

          const lines = trimmed.split(/\r?\n/).filter(l => l.trim() !== '');
          lines.forEach(line => {
            let title = '';
            let message = '';

            try {
              const parsed = JSON.parse(line);
              const items = Array.isArray(parsed) ? parsed : [parsed];
              items.forEach((item: any) => {
                title = item.title || item.type || '';
                message = item.message || item.msg || '';

                if (title || message) {
                  this.incomingQueue.push({ title, message });
                }
              });
              return;
            } catch {
            }

            const titleMatch = line.match(/["']?title["']?\s*:\s*["']([^"']+)["']/i) ||
              line.match(/["']?type["']?\s*:\s*["']([^"']+)["']/i);
            const messageMatch = line.match(/["']?message["']?\s*:\s*["']([^"']+)["']/i) ||
              line.match(/["']?msg["']?\s*:\s*["']([^"']+)["']/i);

            if (titleMatch) {
              title = titleMatch[1];
            }

            if (messageMatch) {
              message = messageMatch[1];
            }

            if (!message && !line.includes('{') && !line.includes('[')) {
              message = line;
            }

            if (title || message) {
              this.incomingQueue.push({
                title: title || 'Processing',
                message: message || 'Please wait...'
              });
            }
          });

          if (!this.processingQueue) {
            this.processQueue().catch(err => { /* ignore here */ });
          }
        },
        error: (err) => {
          this.incomingQueue = [{ title: 'Upload error', message: 'Upload failed. Please try again.' }];
          if (!this.processingQueue) {
            this.processQueue().then(() => {
              this.showUploadLoader = false;
              reject(err);
            });
          } else {
            reject(err);
          }
        },
        complete: () => {
          this.incomingQueue.push({ title: 'Upload Complete', message: `Successfully processed ${this.selectedFile?.name}` });
          if (!this.processingQueue) {
            this.processQueue().then(() => {
              setTimeout(() => {
                this.showUploadLoader = false;
                this.showSpinner = true;

                resolve();
              }, 400);
            });
          } else {
            const waitForFinish = setInterval(() => {
              if (!this.processingQueue) {
                clearInterval(waitForFinish);
                setTimeout(() => { this.showUploadLoader = false; resolve(); }, 300);
              }
            }, 100);
          }
        }
      });
    });
  }

  private async processQueue(): Promise<void> {
    this.processingQueue = true;
    while (this.incomingQueue.length > 0) {
      const item = this.incomingQueue.shift();
      if (!item) { continue; }

      const formattedMessage = this.formatUploadMessage(item.title, item.message);
      this.currentStep = { title: item.title, message: formattedMessage };

      await this.delay(this.displayDelay);
    }

    await this.delay(250);
    this.currentStep = null;
    this.processingQueue = false;
  }

  private formatUploadMessage(title: string, message: string): string {
    const emoji = this.getStatusEmoji(title);

    let cleanMsg = message;

    cleanMsg = cleanMsg.replace(/\.(pdf|docx?|txt|pptx?)$/i, '');

    const cleanTitle = (title || '').replace(/[_-]/g, ' ').trim();
    if (cleanMsg && cleanMsg.toLowerCase() !== cleanTitle.toLowerCase()) {
      return `${emoji} ${cleanMsg}`;
    } else if (cleanTitle) {
      return `${emoji} ${cleanTitle}`;
    }

    return `${emoji} Processing...`;
  }

  private getStatusEmoji(title: string): string {
    const t = (title || '').toLowerCase();
    if (t.includes('start') || t.includes('upload')) return '📤';
    if (t.includes('validat')) return '✅';
    if (t.includes('process') || t.includes('kick')) return '⚙️';
    if (t.includes('extract')) return '📄';
    if (t.includes('complete') || t.includes('success')) return '✅';
    if (t.includes('error') || t.includes('fail')) return '❌';
    if (t.includes('search') || t.includes('index')) return '🔍';
    if (t.includes('save') || t.includes('stor')) return '💾';
    return '🔄';
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private getResponseInConfiguredOrder(internalResponse: string, externalResponse: string): string {
    const responses = this.externalAfterInternal
      ? [internalResponse, externalResponse]
      : [externalResponse, internalResponse];
    return responses.filter(Boolean).join('\n\n');
  }

  // JHUD-5781: Split response into internal/external sections so each group's images sit under its own content; ref docs go on the last section to stay at the end.
  private buildSegregatedResponseSections(
    internalResponse: string,
    externalResponse: string,
    internalImages: StreamImageItem[],
    externalImages: StreamImageItem[],
    documents: any[],
    disDocument: any[],
    chunkContent: any[]
  ): StreamResponseSection[] {
    const makeSection = (answer: string, images: StreamImageItem[]): StreamResponseSection => ({
      answer: this.addLineBreakBeforeSpan(answer || ''),
      documents: [], disDocument: [], chunkContent: [],
      showDoc: false, showAll: false,
      images: images || [], showAllImages: false
    });

    const internalSection = makeSection(internalResponse, internalImages);
    const externalSection = makeSection(externalResponse, externalImages);
    const visibleSections = (this.externalAfterInternal
      ? [internalSection, externalSection]
      : [externalSection, internalSection]
    ).filter((section) => section.answer || section.images.length > 0);

    if (visibleSections.length === 0) {
      return [];
    }

    const lastSection = visibleSections[visibleSections.length - 1];
    lastSection.documents = documents || [];
    lastSection.disDocument = disDocument || [];
    lastSection.chunkContent = chunkContent || [];
    lastSection.showDoc = (disDocument?.length || 0) > 0;

    return visibleSections;
  }

  /** JHUD-5781: Maps a persisted history image into a renderable stream image item. */
  private toStreamImageItem(entry: PersistedImageItem, isInternal: boolean): StreamImageItem {
    return {
      path: entry.image_path,
      src: this.buildStreamImageMetadataUrl(entry.image_path),
      description: entry.image_desc,
      loading: false,
      fileName: entry.filename,
      pageNumber: entry.page_number,
      isInternal
    };
  }

  async checkTextResponse(event?: Event, regenerateResponse?: boolean) {
    this.repeatCount = 0;

    if (this.checktokenExpiry()) {
      this.newAuthService.handleSessionExpiry();
      return;
    }

    const messageText = (this.promptText || '').trim();

    if (this.selectedFile && messageText.length === 0) {
      this.toastr.info('Please add some text with the uploaded file before sending.');
      return;
    }

    this.isPlayGround = false;
    this.isPlayGroundB = false;
    this.isPublicKnowledge = false;
    if (regenerateResponse !== undefined) {
      this.frmStt = regenerateResponse;
    }
    if (event) {
      this.global_mute = false;
      this.mic = false;
      this.mute = true;
    }
    if (this.streamingResponseOn || this.showSpinner) {
      if (event && event.preventDefault) { event.preventDefault(); }
      this.toastr.info('Please wait for the ongoing response before giving a new prompt.');
      return;
    }
    if (!this.promptText || this.promptText.trim() === "") {
      return;
    }

    const textarea = this.textareaRef.nativeElement;
    textarea.style.height = '35px';
    this.showOverlayContentheading = true;
    this.showOverlayContent = false;
    this.showChatFocusContent = false;

    const promptToSend = this.promptText;
    const fileToUpload = this.selectedFile;
    const fileHtmlToSend = this.selectedFileHtml;

    this.promptText = "";
    textarea.value = "";
    this.selectedFileHtml = '';
    textarea.style.height = '35px';

    const uploadRequest: any = {
      chat_user_id: this.userId,
      chat_session_id: this.dataObject?.chat_session_id,
      business_unit_code: sessionStorage.getItem('businessUnitCode')
    };

    // JHUD-5268: image uploads (JPEG/JPG/PNG) also send the typed prompt as user_request
    if (fileToUpload && this.isImageFile(fileToUpload.name)) {
      uploadRequest.user_request = promptToSend;
    }

    const uploadIfNeeded = async (): Promise<void> => {
      this.showSpinner = true;

      if (!fileToUpload) { return; }

      this.selectedFile = fileToUpload;

      try {
        await this.uploadAndStreamResponse(uploadRequest);
      } catch (uploadErr) {
        console.error('File upload failed', uploadErr);
        this.toastr.error('File upload failed. Please try again.');
        throw uploadErr;
      } finally {
        this.storeFile = this.selectedFile
        this.selectedFile = null;
        this.showSpinner = true;

      }
    };

    try {
      this.showSpinner = true;
      this.date = new Date();

      this.pushChatTextContent(promptToSend, 'CS', 'person', '', undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, fileHtmlToSend);

      if (this.createSessionFirstTimeFlag) {
        this.createSessionFirstTimeFlag = false;
        let product = this.PlatformRegionService.selectedProductPlatform.business_unit_code;
        let region = (this.chatRegionMarketService.selected_region_code !== null) ? this.chatRegionMarketService.selected_region_code : this.PlatformRegionService.selected_region_code;
        let market = (this.chatRegionMarketService.selected_market_code !== null) ? this.chatRegionMarketService.selected_market_code : this.PlatformRegionService.selected_market_code;

        var prodValues = sessionStorage.getItem('product').split('~')
        let chatRequest: CreateChatReqRes = {
          chat_user_id: this.userId,
          chat_type: "Chat",
          chat_topic: (this.abioFocusApiText !== "" && this.abioFocusApiText !== undefined) ? this.abioFocusApiText : "",
          business_unit_code: sessionStorage.getItem('businessUnitCode'),
          region_name: region,
          primary_market: market,
          product: product
        };

        this.creatChatSubscription = this.ChatService.createChatSession(chatRequest).subscribe({
          next: async (res: CreateChatReqRes) => {
            try {
              this.dataObject.chat_session_id = res.chat_session_id;
              sessionStorage.setItem("sessionId", res.chat_session_id.toString());

              uploadRequest.chat_session_id = this.dataObject.chat_session_id;
              this.showSpinner = true;

              if (fileToUpload) {
                await uploadIfNeeded();
                this.showSpinner = true;
                this.showUploadLoader = false;
              }

              await this.getTextResponse(promptToSend, false, false, '', null, fileToUpload);
            } catch (err) {
              console.error('Error during chat session flow:', err);
              this.toastr.error('An error occurred. Please try again.');
            } finally {
              //his.showSpinner = false;
              this.showSpinner = true;
            }
          },
          error: (err) => {
            this.showSpinner = false;
            this.toastr.error('Failed to create chat session. Please try again.');
            console.error('createChatSession failed', err);
            //this.clearSelectedFileInput();
          }
        });

      } else {
        uploadRequest.chat_session_id = this.dataObject?.chat_session_id;

        try {
          if (fileToUpload) {
            await uploadIfNeeded();
            this.showSpinner = true;
            this.showUploadLoader = false;
          }

          await this.getTextResponse(promptToSend, false, false, '', null, fileToUpload);
        } catch (err) {
          console.error('Error during text response flow:', err);
          this.toastr.error('An error occurred. Please try again.');
        } finally {
          this.showSpinner = true
        }
      }
    } catch (err) {
      console.error('Unexpected error in checkTextResponse:', err);
      this.showSpinner = false;
    } finally {
      this.setFocus();
    }
    this.storeFile = null;
  }

  clearSelectedFileInput() {
    this.selectedFile = null;
    this.selectedFileHtml = '';
    this.selectedFileName = '';
    const fileInputEl = document.getElementById('file-upload') as HTMLInputElement;
    if (fileInputEl) {
      fileInputEl.value = '';
    }
  }
  pushChatTextContent(
    content: string,
    person: string,
    cssClass: string,
    user_request?: string,
    arrayIndex?: number,
    documents?: any,
    chunkContent?: any,
    foundationModel?: boolean,
    summaryType?: string,
    synthetic_prompt?: any,
    modified_current_prompt?: any,
    disDocument?: any,
    medianChunk?: string,
    uploadedFileHtml?: string,
    total_tokens_utilized?: number,
    total_cost_utilized?: number,
    utilization_token_json?: any,
    chunk_validation_details?: any,
    top_chunks_used?: any,
    first_token_generation_time_sec?: number,
    dedup_audit_entries?: any,
  ) {
    const currentTimeStamp = new Date();
    const shouldUpdateExistingFieldRepMessage = person === 'fieldRep'
      && typeof arrayIndex === 'number'
      && arrayIndex >= 0
      && (this.streamingResponseOn || this.chatConversation[arrayIndex]?.person === 'fieldRep');

    if (shouldUpdateExistingFieldRepMessage) {
      const chatToPush: ChatWithBot = {
        person: person,
        response: content,
        cssClass: cssClass,
        userRequest: user_request,
        timestamp: currentTimeStamp,
        documents: documents,
        showDoc: false,
        showAll: false,
        chunkContent: chunkContent,
        foundationModel: foundationModel,
        summaryType: summaryType,
        synthetic_prompt: synthetic_prompt,
        modified_current_prompt: modified_current_prompt,
        disDocument: disDocument,
        medianChunk: medianChunk,
        uploadedFileHtml: uploadedFileHtml,
        total_tokens_utilized: total_tokens_utilized,
        total_cost_utilized: total_cost_utilized,
        utilization_token_json: utilization_token_json,
        chunk_validation_details: chunk_validation_details,
        top_chunks_used: top_chunks_used,
        dedup_audit_entries: dedup_audit_entries,
        first_token_generation_time_sec: first_token_generation_time_sec,
      };
      this.chatConversation[arrayIndex] = chatToPush;
    } else {
      const chatToPush: ChatWithBot = {
        person: person,
        response: content,
        cssClass: cssClass,
        userRequest: user_request,
        timestamp: currentTimeStamp,
        documents: "",
        showDoc: false,
        showAll: false,
        chunkContent: "",
        foundationModel: foundationModel,
        summaryType: summaryType,
        synthetic_prompt: "",
        modified_current_prompt: "",
        disDocument: "",
        medianChunk: "",
        uploadedFileHtml: uploadedFileHtml,
        total_tokens_utilized: total_tokens_utilized,
        total_cost_utilized: total_cost_utilized,
        utilization_token_json: utilization_token_json,
        chunk_validation_details: chunk_validation_details,
        top_chunks_used: top_chunks_used,
        dedup_audit_entries: dedup_audit_entries,
        first_token_generation_time_sec: first_token_generation_time_sec,
      };
      this.chatConversation.push(chatToPush);
    }

    this.scrollbarObserver = this.setupScrollObserver('#scrollable-prompt');
  }

  setupScrollObserver(containerSelector) {
    const container = document.querySelector(containerSelector);
    const observer = new MutationObserver(() => {
      container.scrollTop = container.scrollHeight;
    });
    observer.observe(container, {
      childList: true,
      subtree: true
    });
    return observer;
  }
  isJsonString(str) {
    if (typeof str !== "string") {
      return false;
    }
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  checktokenExpiry(): boolean {
    const helper = new JwtHelperService();
    const token = localStorage.getItem('bearer_token');
    const decodedToken = helper.decodeToken(token);
    if (!decodedToken) {
      return true;
    }
    const expTimestamp = decodedToken.exp;
    if (typeof expTimestamp === 'undefined') {
      return true;
    }
    const expDate = new Date(expTimestamp * 1000);
    expDate.setSeconds(expDate.getSeconds() - 5);
    const client_id = environment.client_id;
    const now = new Date();
    const isExpired = expDate < now;
    const isInvalidAudience = decodedToken.aud !== client_id;
    return isExpired || isInvalidAudience;
  }

  async getTextResponse(prompt: any, regenerateResponse: boolean = false, foundationModel: boolean = false, feedback?: string, previousID?: number, file?: File) {
    this.isHistoryOn = false;
    if (this.mic) {
      this.tts.resetAudio();
    }
    this.intService.customizationDetails$.subscribe(value => {
      if (value) {
        this.textToSpeechEnabled = value.enable_voice_interaction;
      }
    });
    if (prompt?.trim() === '') {
      return;
    }
    const requestTime = new Date();
    this.requestStartTime = new Date();
    let user_request = prompt;
    this.chatConversationLastUserRequest = prompt;
    let messages: Message[] = [];
    let msg: any = new Message;
    msg.role = "user";
    msg.content = prompt;
    messages.push(msg);
    if (window.innerWidth <= 768) {
      this.applyClass = true;
    }
    let regionName = (this.chatRegionMarketService.selected_region_code !== null) ? [this.chatRegionMarketService.selected_region_code] : [this.PlatformRegionService.selected_region_code];
    this.roleName = sessionStorage.getItem("role");
    let market = (this.chatRegionMarketService.selected_market_code !== null) ? (this.chatRegionMarketService.selected_market_code ? [this.chatRegionMarketService.selected_market_code] : []) : [this.PlatformRegionService.selected_market_code];

    let chatTopic;
    let responseType;
    if (this.isPlayGround) {
      responseType = 'playground';
      chatTopic = 'playground'
    } else if (this.isPlayGroundB) {
      responseType = 'playground-b';
      chatTopic = 'playground-b'
    } else if (this.isPublicKnowledge) {
      responseType = 'response_from_public_knowledge';
      chatTopic = "Chat"
    } else {
      responseType = (this.chatStatus === 'NC') ? "Chat" : (this.abioFocusApiText !== "" && this.abioFocusApiText !== undefined) ? this.abioFocusApiText : "";
      chatTopic = (this.chatStatus === 'NC') ? "Chat" : (this.abioFocusApiText !== "" && this.abioFocusApiText !== undefined) ? this.abioFocusApiText : "";
    }

    var prodValues = sessionStorage.getItem('product').split('~')
    if (file) {

    }
    let aiChatRequest: AiChatLLMRequest = {
      chat_session_id: this.dataObject.chat_session_id,
      user_request: prompt,
      chat_topic: chatTopic,
      regenerate_response: regenerateResponse,
      f_model_response: foundationModel,
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      region_name: regionName,
      //region_id: selectedRegion ? selectedRegion.id : null,
      primary_market: market,//marketName,
      additional_params: { anatomy: [] }, // { anatomy: (sessionStorage.getItem('product') !== 'null' && sessionStorage.getItem('product') !== null) ? prodValues : [] },
      wwid: this.userId,
      role: sessionStorage.getItem('role')?.toLowerCase() || '',
      ...(this.chatStatus !== 'SM' && { response_type: responseType }),
      feedback_comment: feedback,
      previous_chat_history_id: previousID,
      is_internal: true
    }

    this.showSpinner = true;
    this.stopWriting = true;
    const arrayIndex = this.chatConversation.length;
    let tempToken = localStorage.getItem('bearer_token');
    let filterValue = '';
    if (this.chatStatus !== 'SM') {
      // llm api
      var textToAudio = '';
      var removedText = '';

      // --- SSE-based stream handler for new response format ---
      // Track multiple response sections within a single conversation entry
      // Each section = { answer, documents, disDocument, chunkContent }
      let currentSectionIndex = 0;
      let responseSections: StreamResponseSection[] = [
        { answer: '', documents: [], disDocument: [], chunkContent: [], showDoc: false, showAll: false, images: [], showAllImages: false }
      ];
      let sseSyntheticPrompt = '';
      let sseModifiedCurrentPrompt = '';
      let sseTotalTokensUtilized = null;
      let sseTotalCostUtilized = null;
      let sseUtilizationTokenJson = null;
      let sseChunkValidationDetails = null;
      let sseTopChunksUsed = null;
      let sseDedupAuditEntries = null;
      let sseFirstTokenGenerationTimeSec = null;
      let sseMedianChunks: any = null;
      let hasReceivedReferences = false;
      let sseInternalAnswer = '';
      let sseExternalAnswer = '';
      let sseInternalImages: PersistedImageItem[] = [];
      let sseExternalImages: PersistedImageItem[] = [];
      this.streamProgressSteps = [];
      this.showStreamProgress = true;

      const upsertPersistedImages = (
        target: PersistedImageItem[],
        entries: StreamImageEntry[]
      ): PersistedImageItem[] => {
        const imageMap = new Map<string, PersistedImageItem>();
        target.forEach((item) => {
          imageMap.set(item.image_path, item);
        });
        entries.forEach((entry) => {
          const path = this.normalizeStreamImagePath(entry.path);
          if (!path) {
            return;
          }
          const existing = imageMap.get(path);
          imageMap.set(path, {
            image_path: path,
            image_desc: String(entry.description || '').trim(),
            filename: String(entry.fileName || existing?.filename || '').trim(),
            page_number: entry.pageNumber ?? existing?.page_number
          });
        });
        return Array.from(imageMap.values());
      };

      // Helper to push the single conversation entry with all sections
      const pushCurrentContent = () => {
        // Combined documents/chunkContent for backward compatibility
        const allDocuments = responseSections.reduce((acc, s) => acc.concat(s.documents), []);
        const allChunkContent = responseSections.reduce((acc, s) => acc.concat(s.chunkContent), []);
        const allDisDocuments = responseSections.reduce((acc, s) => acc.concat(s.disDocument), []);

        let renderedResponseSections: StreamResponseSection[];
        if (this.enableResponseSplit && (sseInternalAnswer || sseExternalAnswer)) {
          // JHUD-5781: segregate images so internal images render under internal content and external under external.
          const allImages = responseSections.reduce(
            (acc, s) => acc.concat(s.images), [] as StreamImageItem[]
          );
          const internalStreamImages = allImages.filter((img) => img.isInternal === true);
          const externalStreamImages = allImages.filter((img) => img.isInternal === false);
          renderedResponseSections = this.buildSegregatedResponseSections(
            sseInternalAnswer,
            sseExternalAnswer,
            internalStreamImages,
            externalStreamImages,
            allDocuments,
            allDisDocuments,
            allChunkContent
          );
        } else {
          renderedResponseSections = responseSections.map(section => ({
            ...section,
            answer: this.addLineBreakBeforeSpan(section.answer)
          }));
        }

        // Combined response text (for compatibility with existing features like copy, TTS)
        const combinedResponse = renderedResponseSections.map(s => s.answer).join('\n\n');

        this.docArr = allDocuments;
        this.showArr = allDisDocuments;

        this.pushChatTextContent(
          combinedResponse,
          'fieldRep',
          'bot',
          user_request,
          arrayIndex,
          allDocuments,
          allChunkContent,
          foundationModel,
          "",
          sseSyntheticPrompt,
          sseModifiedCurrentPrompt,
          allDisDocuments,
          sseMedianChunks,
          '',
          sseTotalTokensUtilized,
          sseTotalCostUtilized,
          sseUtilizationTokenJson,
          sseChunkValidationDetails,
          sseTopChunksUsed,
          sseFirstTokenGenerationTimeSec,
          sseDedupAuditEntries
        );

        // Attach responseSections to the conversation entry for template rendering
        if (this.chatConversation[arrayIndex]) {
          this.chatConversation[arrayIndex].responseSections = renderedResponseSections;
          this.chatConversation[arrayIndex].internalResponse = sseInternalAnswer;
          this.chatConversation[arrayIndex].externalResponse = sseExternalAnswer;
          this.chatConversation[arrayIndex].internalImages = sseInternalImages;
          this.chatConversation[arrayIndex].externalImages = sseExternalImages;
        }
      };

      this.sseStreamSubscription = this.ChatService.getSSEStreamedData(aiChatRequest, filterValue).subscribe({
        next: (sseEvent: { event: string; data: any }) => {
          this.responseTime = new Date();

          switch (sseEvent.event) {

            case 'progress':
              const progressData = sseEvent.data as StreamProgressStep;
              // Update or add the progress step
              const existingIdx = this.streamProgressSteps.findIndex(s => s.step === progressData.step);
              if (existingIdx >= 0) {
                this.streamProgressSteps[existingIdx] = progressData;
              } else {
                this.streamProgressSteps.push(progressData);
              }
              // Show progress bar when new progress events arrive
              if (progressData.status === 'started') {
                this.showStreamProgress = true;
              }
              // Once generation starts, hide progress and show waiting state
              if (progressData.step === 'Generating the Answer' && progressData.status === 'started') {
                this.showStreamProgress = false;
                this.waitingForResponse = true;
                this.streamingResponseOn = true;
                this.showSpinner = false;
              }
              break;

            case 'answer':
              // If we already received references for the current section, start a new section
              if (hasReceivedReferences && responseSections[currentSectionIndex].answer.length > 0) {
                currentSectionIndex++;
                responseSections.push({ answer: '', documents: [], disDocument: [], chunkContent: [], showDoc: false, showAll: false, images: [], showAllImages: false });
                hasReceivedReferences = false;
              }
              // Extract label and answer from the data object or string
              let answerChunk = '';
              let answerLabel = '';
              if (typeof sseEvent.data === 'string') {
                answerChunk = sseEvent.data;
              } else if (sseEvent.data && typeof sseEvent.data === 'object') {
                answerChunk = sseEvent.data.answer || '';
                answerLabel = sseEvent.data.label || '';
              }
              
              // Render images from image labels and persist them for chat_history payload.
              if (answerLabel === 'internal_image' || answerLabel === 'external_image') {
                const currentSection = responseSections[currentSectionIndex];
                const imageEntries = this.extractInternalImageEntries(sseEvent.data?.answer ?? answerChunk);

                if (answerLabel === 'internal_image') {
                  sseInternalImages = upsertPersistedImages(sseInternalImages, imageEntries);
                } else {
                  sseExternalImages = upsertPersistedImages(sseExternalImages, imageEntries);
                }

                imageEntries.forEach((entry) => {
                  const normalizedPath = this.normalizeStreamImagePath(entry.path);
                  if (!normalizedPath) {
                    return;
                  }
                  const duplicateExists = currentSection.images.some((img) => img.path === normalizedPath);
                  if (duplicateExists) {
                    return;
                  }

                  const imageRef: StreamImageItem = {
                    path: normalizedPath,
                    description: entry.description,
                    src: '',
                    loading: true,
                    fileName: entry.fileName,
                    pageNumber: entry.pageNumber,
                    isInternal: answerLabel === 'internal_image'
                  };
                  currentSection.images.push(imageRef);
                  this.resolveStreamImageUrl(normalizedPath).then((resolvedUrl) => {
                    imageRef.src = resolvedUrl;
                    imageRef.loading = false;
                    pushCurrentContent();
                  }).catch(() => {
                    imageRef.src = this.buildStreamImageMetadataUrl(normalizedPath);
                    imageRef.loading = false;
                    pushCurrentContent();
                  });
                });

                this.streamingResponseOn = true;
                this.waitingForResponse = false;
                this.showSpinner = false;
                this.showStreamProgress = false;
                pushCurrentContent();
                break;
              }

              // Track internal and external answers separately
              if (answerLabel === 'internal') {
                sseInternalAnswer += answerChunk;
              } else if (answerLabel === 'external') {
                sseExternalAnswer += answerChunk;
              }

              // Accumulate and immediately render each streaming token
              responseSections[currentSectionIndex].answer += answerChunk;
              this.streamingResponseOn = true;
              this.waitingForResponse = false;
              this.showSpinner = false;
              this.showStreamProgress = false;

              pushCurrentContent();
              break;

            case 'references':
              // Map references to section's documents/chunkContent/disDocument
              // API sends { references_raw: "[...]", documents: [...] } or a direct array
              // Only use documents array if items have expected fields (location, doc_details)
              let referencesData: any[] = [];
              if (Array.isArray(sseEvent.data)) {
                referencesData = sseEvent.data;
              } else if (sseEvent.data?.documents && Array.isArray(sseEvent.data.documents)
                && sseEvent.data.documents.length > 0 && sseEvent.data.documents[0].doc_details) {
                referencesData = sseEvent.data.documents;
              } else if (sseEvent.data?.references_raw) {
                try {
                  const parsed = typeof sseEvent.data.references_raw === 'string'
                    ? JSON.parse(sseEvent.data.references_raw)
                    : sseEvent.data.references_raw;
                  referencesData = Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                  console.error('Error parsing references_raw', e);
                  referencesData = [];
                }
              }

              const currentSection = responseSections[currentSectionIndex];
              referencesData.forEach((item) => {
                // Normalize page_number: handle number, array, [null], null, undefined
                let pageNum = item.page_number ?? item.page_no;
                if (Array.isArray(pageNum)) {
                  pageNum = pageNum[0];
                }
                if (pageNum === null || pageNum === undefined) {
                  pageNum = undefined;
                }
                const rawFileName = item.doc_details?.file_name || item.file_name || item.doc_name;
                const docName = ((item.location || '').toLowerCase() === 'eifu' && item.is_reference !== 'N' && item.doc_details)
                  ? (item.doc_details.data_source + '-' + item.doc_details.document_title)
                  : rawFileName;
                const document_id = item.doc_details?.document_id || item.document_id || null;

                if (item.is_reference !== 'N') {
                  currentSection.documents.push({
                    score: item.score,
                    doc_name: docName,
                    page_numbers: pageNum != null ? [pageNum] : [],
                    chunkContent: item.chunk_text,
                    file_url: item.file_url,
                    start_time: item.doc_details?.start_time ?? item.start_time,
                    end_time: item.doc_details?.end_time ?? item.end_time,
                    deeplink_url: item.doc_details?.deeplink_url ?? item.deeplink_url,
                    showpad_doc_name: item.doc_details?.showpad_doc_name ?? item.showpad_doc_name,
                    showpad_doc_url: item.doc_details?.showpad_doc_url ?? item.showpad_doc_url ?? item.doc_details?.ShowpadUrl ?? item.ShowpadUrl,
                    answer_grade: item.answer_grade,
                    is_internal: item.is_internal,
                    document_id: document_id
                  });
                }
                currentSection.chunkContent.push({
                  location: item.location,
                  doc_name: docName,
                  chunk_id: item.chunk_id,
                  page_no: pageNum,
                  is_reference: item.is_reference,
                  score: item.score,
                  chunk_text: item.chunk_text,
                  file_url: item.file_url,
                  start_time: item.doc_details?.start_time ?? item.start_time,
                  end_time: item.doc_details?.end_time ?? item.end_time,
                  deeplink_url: item.doc_details?.deeplink_url ?? item.deeplink_url,
                  showpad_doc_name: item.doc_details?.showpad_doc_name ?? item.showpad_doc_name,
                  showpad_doc_url: item.doc_details?.showpad_doc_url ?? item.showpad_doc_url ?? item.doc_details?.ShowpadUrl ?? item.ShowpadUrl,
                  file_name: rawFileName,
                  answer_grade: item.answer_grade,
                  is_internal: item.is_internal,
                  document_id: document_id
                });
              });

              // Build disDocument (showArr) for the current section
              currentSection.disDocument = [];
              const newDocArr = this.processShowMoreDocs(currentSection.chunkContent);
              newDocArr.forEach((item) => {
                currentSection.disDocument.push({
                  score: item.score,
                  doc_name: `${item.doc_name}`,
                  page_numbers: item.pages,
                  chunkContent: item.chunk_text,
                  file_url: item.file_url,
                  durations: item.durations,
                  is_internal: item.is_internal,
                  showpad_doc_name: item.showpad_doc_name,
                  showpad_doc_url: item.showpad_doc_url,
                  document_id: item.document_id
                });
              });

              // Mark section as having docs to show
              if (currentSection.documents.length > 0) {
                currentSection.showDoc = true;
                currentSection.showAll = false;
              }

              // Capture median_chunks from the references event for create_chat_history
              if (sseEvent.data?.median_chunks != null) {
                sseMedianChunks = sseEvent.data.median_chunks;
              }

              hasReceivedReferences = true;

              // Re-push to update conversation with reference metadata
              if (currentSection.answer) {
                pushCurrentContent();
              }
              break;

            case 'followup':
              // Map followup questions to existing supplement questions (query array)
              const followupData = sseEvent.data;
              this.handleResponse(followupData);
              break;

            case 'synthetic':
              // Map synthetic data for chat_history API
              const syntheticData = sseEvent.data;
              if (Array.isArray(syntheticData) && syntheticData.length > 0) {
                sseSyntheticPrompt = syntheticData[0]?.synthetic_prompt || '';
                sseModifiedCurrentPrompt = syntheticData[0]?.modified_current_prompt || '';
              } else if (syntheticData && typeof syntheticData === 'object') {
                sseSyntheticPrompt = syntheticData.synthetic_prompt || '';
                sseModifiedCurrentPrompt = syntheticData.modified_current_prompt || '';
              }
              // Update conversation entry with synthetic data
              if (responseSections[currentSectionIndex].answer) {
                pushCurrentContent();
              }
              break;

            case 'cost':
              // Map cost data for display and chat_history API
              const costData = sseEvent.data;
              sseTotalTokensUtilized = costData?.total_tokens_utilized ?? costData?.data?.total_tokens_utilized ?? null;
              sseTotalCostUtilized = costData?.total_cost_utilized ?? costData?.data?.total_cost_utilized ?? null;
              sseUtilizationTokenJson = costData;
              sseFirstTokenGenerationTimeSec = costData?.first_token_generation_time_sec ?? costData?.data?.first_token_generation_time_sec ?? null;

              // Push updated cost data to conversation
              if (responseSections[currentSectionIndex].answer) {
                pushCurrentContent();
              }
              break;

            case 'validation':
              const validationData = sseEvent.data;
              sseChunkValidationDetails = validationData?.chunk_validation_details ?? null;
              sseTopChunksUsed = validationData?.top_chunks_used ?? null;
              sseDedupAuditEntries = validationData?.dedup_audit_entries ?? null;

              if (responseSections[currentSectionIndex].answer) {
                pushCurrentContent();
              }
              break;

            case 'error':
              // Handle error events from stream
              const errorData = sseEvent.data;
              const errorMsg = errorData?.friendly_message || errorData?.message || 'An error occurred. Please try again.';
              this.docArr = [];
              this.showStreamProgress = false;
              this.toastr.error(errorMsg, '', { positionClass: 'toast-top-right' });
              this.pushChatTextContent(errorMsg, 'fieldRep', 'bot', '', arrayIndex, []);
              break;

            default:
              // Unknown event type - ignore
              break;
          }
        },
        complete: () => {
          this.showStreamProgress = false;
          this.waitingForResponse = false;

          // Ensure full response is rendered
          pushCurrentContent();

          if (this.scrollbarObserver) {
            this.scrollbarObserver.disconnect();
          }
          const responseTime = new Date();
          this.streamingResponseOn = false;
          this.showSpinner = false;
          this.stopWriting = false;

          // Combine all section answers for text-to-speech
          const fullAnswer = this.enableResponseSplit
            ? this.getResponseInConfiguredOrder(sseInternalAnswer, sseExternalAnswer)
            : responseSections.map(s => s.answer).filter(a => a).join('\n');
          // Handle text-to-speech for final response
          if (fullAnswer && this.global_mute) {
            this.mute = false;
          }
          if (fullAnswer && this.textToSpeechEnabled && this.frmStt && !this.mute) {
            this.tts.speak(fullAnswer);
          }

          this.chatConversationLastResponseIndex = this.chatConversation.length - 1;
          if (this.docArr.length > 0) {
            this.chatConversation[this.chatConversationLastResponseIndex].showDoc = true;
          }
          if (!this.isRepeat || this.repeatCount > 1) {
            this.saveChatResponse(requestTime, responseTime, foundationModel, prompt, this.isPublicKnowledge, previousID);
          }
        },
        error: (err) => {
          this.showStreamProgress = false;
          this.waitingForResponse = false;
          this.showSpinner = false;
          this.streamingResponseOn = false;
          this.stopWriting = false;
          this.toastr.error('An error occurred while processing your request. Please try again.', '', { positionClass: 'toast-top-right' });
        }
      });
    } else { // Summarizer Text and QnA

      if (this.firstTimeSummarizer) { // Summarize Text
        this.firstTimeSummarizer = false;
        let request: any = {
          chat_session_id: this.dataObject.chat_session_id,
          user_request: user_request,
          business_unit_code: sessionStorage.getItem('businessUnitCode')
        }
        this.ChatService.summarizerTextContent(request).subscribe({
          next: (res) => {
            if (res.error && Array.isArray(res.error) && res.error.length > 0 && !(res?.error?.some(err => err.includes(searchString)))) {
              this.toastr.error(res.error.join(', '), '', { positionClass: 'toast-top-right' });
              this.showSpinner = false;
              this.streamingResponseOn = false;
              this.stopWriting = false;
              if (this.global_mute) {
                this.mute = false;
              }
              this.pushChatTextContent(res.error.join(', '), 'fieldRep', 'bot', '', arrayIndex, []);
            } else if ((Array.isArray(res) && res[0]?.hasOwnProperty('error_code')) || (typeof res === 'string' && res.includes('error_code'))) {
              this.showSpinner = false;
              this.docArr = this.showArr = [];
              let friendly: string | null = null;

              if (Array.isArray(res)) {
                friendly = res[0]?.friendly_message ?? null;
              } else {
                const part = (res as string).split('<<--||-->>')[0];
                try {
                  const p = JSON.parse(part);
                  friendly = Array.isArray(p) ? p[0]?.friendly_message : p?.friendly_message;
                } catch {
                  const m = part.match(/friendly_message['"]?\s*:\s*['"]([^'"]+)/);
                  friendly = m?.[1] ?? null;
                }
              }

              const msg = friendly ?? (typeof res === 'string' ? res : JSON.stringify(res));
              this.toastr.error(msg);
              this.pushChatTextContent(msg, 'fieldRep', 'bot', '', arrayIndex, []);
            } else if (res?.error?.some(err => err.includes(searchString))) {
              this.showSpinner = false;
              this.streamingResponseOn = false;
              this.stopWriting = false;
              if (this.global_mute) {
                this.mute = false;
              }
              this.newAuthService.handleSessionExpiry();
            } else {
              if (res.document_summary) {
                this.streamingResponseOn = false;
                this.showSpinner = false;
                this.stopWriting = false;
                if (this.global_mute) {
                  this.mute = false;
                }
                if (this.textToSpeechEnabled && !this.mute) {
                  this.tts.speak(res.document_summary);
                }
                this.chatConversationLastResponseIndex = this.chatConversation.length - 1;
                if (this.docArr.length > 0)
                  this.chatConversation[this.chatConversationLastResponseIndex].showDoc = true;
                this.pushChatTextContent(res.document_summary, 'fieldRep', 'bot', user_request, 0, [], [], false, 'TEXTSUMMARY',);

              }

            }
            setTimeout(() => {
              this.chatConversation[this.chatConversation.length - 1]["chat_conversation_id"] = res.id;
              this.chatConversation[this.chatConversation.length - 1]["likedislike"] = "Empty";
              //this.chatConversation[this.chatConversation.length - 1]["regenerate"] = "show";
            });
          }, complete: () => {
            // if(this.mic){
            //   setTimeout(() => {
            //     this.mute = true;
            //   }, 1000);
            //   }
            this.refreshHistory();
          },
          error: (err) => {
            this.showSpinner = false;
            this.toastr.error('Summarization failed..Please try again.', '', { positionClass: 'toast-top-right' });
          },
        });
      } else { // QNA for previous file/text
        let request: any = {
          chat_session_id: this.dataObject.chat_session_id,
          user_request: prompt,
          regenerate_response: regenerateResponse,
          f_model_response: false,
          business_unit_code: sessionStorage.getItem('businessUnitCode'),
          wwid: this.userId,
          chat_topic: chatTopic
        }
        this.summarizerQandASubscription = this.ChatService.summarizerQandA(request).subscribe({
          next: (chunk: string) => {
            if (chunk.includes(searchString)) {
              this.newAuthService.handleSessionExpiry();
            } else if (chunk.includes("error_code")) {
              let responseArr: any = JSON.parse(chunk);
              this.docArr = [];
              this.toastr.error(responseArr[0].friendly_message);
              this.pushChatTextContent(responseArr[0].friendly_message, 'fieldRep', 'bot', '', arrayIndex, []);
            } else {
              this.docArr = [];
              this.showArr = []
              let chunkContent: Array<{ location: string; doc_name: string; chunk_id: Array<string>; page_no: number; chunk_text: string, file_url: string, file_name: string, showpad_doc_name?: string; showpad_doc_url?: string }> = [];
              let responseArr = chunk.split("<<--||-->>");
              let length = responseArr.length;
              this.streamingResponseOn = true;
              this.showSpinner = false;
              if (responseArr.length > 1) {
                let synthetic_prompt: any;
                let modified_current_prompt: any;
                // let obj = JSON.parse(responseArr[1]);
                let obj = this.isJsonString(responseArr[length - 1]) ? JSON.parse(responseArr[length - 1]) : "";
                if (obj && obj.length > 0) {
                  synthetic_prompt = obj[0].synthetic_prompt;
                  modified_current_prompt = obj[0].modified_current_prompt;
                } else {
                  synthetic_prompt = '';
                  modified_current_prompt = '';
                }
                // Reference documents from LLM Response
                if (responseArr.length > 4) {
                  let referenceDocArr = JSON.parse(responseArr[2]);

                  referenceDocArr.forEach((item) => {
                    let docName = ((item.location || '').toLowerCase() === 'eifu' && item.is_reference !== 'N') ? (item.doc_details.data_source + '-' + item.doc_details.document_title) : item.doc_details.file_name;
                    this.docArr.push({
                      score: item.score,
                      doc_name: docName,//`${item.doc_name}`,
                      page_numbers: item.page_no,
                      file_url: item.file_url,
                      showpad_doc_name: item.doc_details?.showpad_doc_name ?? item.showpad_doc_name,
                      showpad_doc_url: item.doc_details?.showpad_doc_url ?? item.showpad_doc_url ?? item.doc_details?.ShowpadUrl ?? item.ShowpadUrl
                    });
                    chunkContent.push({
                      location: item.location,
                      doc_name: docName,
                      chunk_id: item.chunk_id,
                      page_no: item.page_no,
                      chunk_text: item.chunk_text,
                      file_url: item.file_url,
                      file_name: item.doc_details.file_name,
                      showpad_doc_name: item.doc_details?.showpad_doc_name ?? item.showpad_doc_name,
                      showpad_doc_url: item.doc_details?.showpad_doc_url ?? item.showpad_doc_url ?? item.doc_details?.ShowpadUrl ?? item.ShowpadUrl
                    });
                  });
                  let newDocArr = this.processShowMoreDocs(chunkContent);
                  newDocArr.forEach((item) => {
                    let score = item.score;
                    this.showArr.push({
                      score: score,
                      doc_name: `${item.doc_name}`,
                      page_numbers: item.pages,
                      chunkContent: item.chunk_text,
                      file_url: item.file_url,
                      showpad_doc_name: item.showpad_doc_name,
                      showpad_doc_url: item.showpad_doc_url
                    });
                  })
                }
                this.chunk = responseArr[1];
                this.pushChatTextContent(responseArr[1], 'fieldRep', 'bot', user_request, arrayIndex, this.docArr, chunkContent, foundationModel, 'QNASUMMARY', synthetic_prompt, modified_current_prompt, this.showArr);
              } else {
                this.chunk = chunk;
                this.pushChatTextContent(chunk, 'fieldRep', 'bot', user_request, arrayIndex, []);
              }

            }
          },
          complete: () => {
            const responseTime = new Date();
            this.streamingResponseOn = false;
            this.showSpinner = false;
            this.stopWriting = false;
            if (this.textToSpeechEnabled && !this.mute) {
              this.tts.speak(this.chunk);
            }
            if (this.mic) {
              setTimeout(() => {
                this.mute = false;
              }, 1000);
            }
            this.chatConversationLastResponseIndex = this.chatConversation.length - 1;
            if (this.docArr.length > 0)
              this.chatConversation[this.chatConversationLastResponseIndex].showDoc = true;
            this.saveChatResponse(requestTime, responseTime, true, prompt);
          },
          error: (err) => {
            this.showSpinner = false;
            this.streamingResponseOn = false;
            this.stopWriting = false;
          }
        });

      }

    }

  }
  handleResponse(responseArr: any) {
    if (responseArr == null) {
      this.query = [];
      return;
    }
    this.query = Array.isArray(responseArr) ? responseArr : [responseArr];
  }

  onKeydown(event) {
    event.preventDefault();
  }
  /**
   * Normalizes a chunk document item to a consistent shape that works
   * for both the web/AMP format (root-level fields) and the native app
   * format (doc_details wrapper, page_number instead of page_no).
   */
  private normalizeChunkDoc(doc: any): any {
    const details = doc.doc_details || {};
    return {
      ...doc,
      // file name: prefer root doc_name/file_name, then doc_details.file_name
      doc_name: doc.doc_name || doc.file_name || details.file_name || details.document_title || '',
      // page: root page_no takes priority, fall back to native page_number
      page_no: doc.page_no ?? doc.page_number,
      // media timing & deep-link: prefer root fields, fall back to doc_details
      start_time: doc.start_time !== undefined ? doc.start_time : details.start_time,
      end_time: doc.end_time !== undefined ? doc.end_time : details.end_time,
      deeplink_url: doc.deeplink_url !== undefined ? doc.deeplink_url : details.deeplink_url,
      showpad_doc_name: doc.showpad_doc_name !== undefined ? doc.showpad_doc_name : details.showpad_doc_name,
      showpad_doc_url: doc.showpad_doc_url !== undefined ? doc.showpad_doc_url : (doc.ShowpadUrl !== undefined ? doc.ShowpadUrl : (details.showpad_doc_url !== undefined ? details.showpad_doc_url : details.ShowpadUrl)),
      document_id: doc.document_id !== undefined ? doc.document_id : details.document_id,
    };
  }

  processShowMoreDocs(referenceDocArr = []) {
    const docMap = {};
    const eiFuEntries = [];

    function isMediaFile(name = '') {
      return /\.(mp3|mp4|mkv|mov)$/i.test(name.trim());
    }

    function normalizeTimeField(field) {
      if (Array.isArray(field)) return field[0];
      return field ?? null;
    }

    function buildPlayUrl(item) {
      const raw = item.deeplink_url || item.file_url || '';
      const base = raw.split('#')[0] || '';
      const start = normalizeTimeField(item.start_time);
      const end = normalizeTimeField(item.end_time);

      if (!base) return raw || null;

      if (!start && !end) return base;
      return `${base}#t=${start || ''},${end || ''}`;
    }

    referenceDocArr.forEach(item => {
      const docKey = `${item.doc_name || ''}::${item.document_id || ''}::${String(item.location ?? '').toLowerCase()}`;
      const showpadUrl = item.showpad_doc_url ?? item.ShowpadUrl;
      // Normalize page number: handle number, array, [null], null, undefined
      let pageNum = item.page_no ?? item.page_number;
      if (Array.isArray(pageNum)) {
        pageNum = pageNum[0];
      }
      if (pageNum === null || pageNum === undefined) {
        pageNum = undefined;
      }

      const isEiFu = String(item.location ?? '').trim().toLowerCase() === 'eifu';
      const media = isMediaFile(item.doc_name);

      // Do not skip non-media items without page numbers; show them with empty pages

      const common = {
        score: item.score,
        doc_name: item.doc_name,
        chunk_text: item.chunk_text,
        location: item.location,
        is_internal: item.is_internal,
        showpad_doc_name: item.showpad_doc_name,
        showpad_doc_url: showpadUrl,
        document_id: item.document_id
      };

      // eIFU-specific handling is commented

      if (isEiFu && item.is_reference !== 'N') {
        if (media) {
          const start = normalizeTimeField(item.start_time);
          const end = normalizeTimeField(item.end_time);
          const playUrl = buildPlayUrl(item);

          eiFuEntries.push({
            ...common,
            duration: { start, end },
            playUrl
          });
        } else {
          eiFuEntries.push({
            ...common,
            pages: [pageNum]
          });
        }
        return;
      }


      if (!docMap[docKey]) {
        if (media) {
          const start = normalizeTimeField(item.start_time);
          const end = normalizeTimeField(item.end_time);
          const playUrl = buildPlayUrl(item);

          docMap[docKey] = {
            ...common,
            durations: []
          };

          if (start || end) {
            docMap[docKey].durations.push({ start, end, playUrl });
          }
        } else {
          docMap[docKey] = {
            ...common,
            pages: pageNum != null ? [pageNum] : []
          };
        }
      } else {
        if (!docMap[docKey].showpad_doc_url && showpadUrl) {
          docMap[docKey].showpad_doc_url = showpadUrl;
        }
        if (item.showpad_doc_name && showpadUrl && !docMap[docKey].showpad_doc_name) {
          docMap[docKey].showpad_doc_name = item.showpad_doc_name;
        }

        if (media) {
          const start = normalizeTimeField(item.start_time);
          const end = normalizeTimeField(item.end_time);
          const playUrl = buildPlayUrl(item);

          docMap[docKey].durations = docMap[docKey].durations || [];

          const exists = docMap[docKey].durations.some(d =>
            (d.start === start && d.end === end)
          );
          if (!exists && (start || end)) {
            docMap[docKey].durations.push({ start, end, playUrl });
          }
        } else {
          docMap[docKey].pages = docMap[docKey].pages || [];
          if (pageNum != null && !docMap[docKey].pages.includes(pageNum)) {
            docMap[docKey].pages.push(pageNum);
          }
        }
      }
    });

    const uniqueDocs = Object.values(docMap).map(entry => entry);
    return [...uniqueDocs, ...eiFuEntries];
  }
  formatDurationDot(timeInput: any): string {
    const t = this.normalizeTimeField(timeInput);
    if (!t) return '';

    const parts = t.split(':').map(p => p.trim());
    let hours = 0, minutes = 0, secondsFloat = 0;

    if (parts.length === 3) {
      hours = parseInt(parts[0], 10) || 0;
      minutes = parseInt(parts[1], 10) || 0;
      secondsFloat = parseFloat(parts[2]) || 0;
    } else if (parts.length === 2) {
      minutes = parseInt(parts[0], 10) || 0;
      secondsFloat = parseFloat(parts[1]) || 0;
    } else {
      secondsFloat = parseFloat(parts[0]) || 0; // treat single value as seconds
    }

    const totalSeconds = hours * 3600 + minutes * 60 + secondsFloat;
    const totalMinutes = Math.floor(totalSeconds / 60);
    let secs = Math.round(totalSeconds - totalMinutes * 60);

    // handle rounding edge case (e.g., 59.6 -> 60)
    if (secs === 60) {
      secs = 0;
      // optionally: increment totalMinutes if you want strict rounding
      // totalMinutes += 1;
    }

    const secStr = secs < 10 ? `0${secs}` : `${secs}`;
    return `${totalMinutes}.${secStr}`;
  }

  normalizeTimeField(field: any): string | null {
    if (field == null) return null;
    return Array.isArray(field) ? String(field[0]) : String(field);
  }



  speak(text: string): void {
    this.tts.synthesizeSpeech(text);
  }

  checkCharacters(char) {
    let charArray = ["\n", "\n\n"]
    if (charArray.includes(char)) {
      return false;
    } else {
      return true;
    }
  }
  saveChatResponse(requestTime: Date, responseTime: Date, foundationModel?: boolean, prompt?: string, isPublicKnowledge?: boolean, previousID?: number) {
    const length: number = this.chatConversation.length;
    // let user_request: string = "";
    let bot_answer: string = "";
    let internalResponse = '';
    let externalResponse = '';
    let internalImages: PersistedImageItem[] = [];
    let externalImages: PersistedImageItem[] = [];
    let combinedResponse = '';
    // if (this.chatConversation[length - 2].person == 'CS') {
    //   user_request = this.chatConversation[length - 2].response;
    // }
    if (this.chatConversation[length - 1].person == 'fieldRep') {
      internalResponse = this.chatConversation[length - 1].internalResponse || '';
      externalResponse = this.chatConversation[length - 1].externalResponse || '';
      internalImages = this.normalizePersistedImageItems(this.chatConversation[length - 1].internalImages || []);
      externalImages = this.normalizePersistedImageItems(this.chatConversation[length - 1].externalImages || []);
      combinedResponse = this.chatConversation[length - 1].response || '';
      if (internalResponse || externalResponse || internalImages.length > 0 || externalImages.length > 0) {
        const internalImageJson = JSON.stringify(internalImages);
        const externalImageJson = JSON.stringify(externalImages);
        if (this.enableResponseSplit) {
          bot_answer = JSON.stringify({
            internal: internalResponse,
            external: externalResponse,
            internal_image: internalImageJson,
            external_image: externalImageJson
          });
        } else {
          bot_answer = JSON.stringify({
            internal: combinedResponse,
            external: '',
            internal_image: internalImageJson,
            external_image: externalImageJson
          });
        }
      } else {
        bot_answer = combinedResponse;
      }
      //this.tts.synthesizeSpeech(bot_answer);
      if (this.global_mute) {
        this.mute = false;
      }

      if (foundationModel && !this.mute && this.textToSpeechEnabled) {
        // this.tts.speak(bot_answer);
        if (this.chatStatus !== 'SM') {
          this.mic = false;
        }
        if (this.mic) {
          this.mute = true;
        }
      }
    }

    let documents = this.chatConversation[length - 1].chunkContent || [];
    let docArr = [];
    if (documents.length > 0) {
      documents.forEach((item) => {
        docArr.push(item.doc_name);
      });
    }

    //const isPublicKnowledge = false;
    const isRegenerated = false;
    let regionName = (this.chatRegionMarketService.selected_region_code !== null) ? [this.chatRegionMarketService.selected_region_code] : [this.PlatformRegionService.selected_region_code];
    let market = (this.chatRegionMarketService.selected_market_code !== null) ? (this.chatRegionMarketService.selected_market_code ? this.chatRegionMarketService.selected_market_code.split(',') : []) : [this.PlatformRegionService.selected_market_code];
    // chatValues.chunkContent[chunkContentIndex].location;
    let synthetic_prompt: any = this.chatConversation[length - 1].synthetic_prompt;
    let modified_current_prompt: any = this.chatConversation[length - 1].modified_current_prompt;
    const rawMedianChunk = this.chatConversation[length - 1].medianChunk;
    let median_chunk: any = rawMedianChunk != null ? JSON.stringify(rawMedianChunk) : null;
    let total_tokens_utilized = this.chatConversation[length - 1].total_tokens_utilized;
    let total_cost_utilized = this.chatConversation[length - 1].total_cost_utilized;
    let utilization_token_json = this.chatConversation[length - 1].utilization_token_json;
    let chunk_validation_details = this.chatConversation[length - 1].chunk_validation_details;
    let top_chunks_used = this.chatConversation[length - 1].top_chunks_used;
    let dedup_audit_entries = this.chatConversation[length - 1].dedup_audit_entries;
    let chatTopic;
    let responseType;
    if (this.isPlayGround) {
      responseType = 'playground';
      chatTopic = 'playground'
    } else if (this.isPlayGroundB) {
      responseType = 'playground-b';
      chatTopic = 'playground-b'
    } else if (isPublicKnowledge) {
      responseType = 'public_knowledge';
      chatTopic = "Chat"
    } else {
      responseType = (this.chatStatus === 'NC') ? "Chat" : (this.abioFocusApiText !== "" && this.abioFocusApiText !== undefined) ? this.abioFocusApiText : "";
      chatTopic = (this.chatStatus === 'NC') ? "Chat" : (this.abioFocusApiText !== "" && this.abioFocusApiText !== undefined) ? this.abioFocusApiText : "";
    }
    let fileName: string | undefined;
    if (this.storeFile && this.storeFile.name) {
      fileName = this.userId + '_' + this.storeFile.name;
    }
    const requestPayload: SendChatResponse = {
      user_request: prompt,
      bot_response: bot_answer,
      internal_response: this.enableResponseSplit ? (internalResponse || combinedResponse) : combinedResponse,
      external_response: this.enableResponseSplit ? externalResponse : '',
      chat_session_id: this.dataObject.chat_session_id,
      reference_document: docArr.toString() || "",
      chunk_content: JSON.stringify(documents) || "",
      f_model_response: foundationModel,
      regenerate_response: this.isRegenerated,
      request_time: requestTime.toISOString(),
      response_time: responseTime.toISOString(),
      is_voice: this.mic ? "Yes" : "No",
      region_name: regionName,
      primary_market: market,
      synthetic_prompt: synthetic_prompt,
      modified_current_prompt: modified_current_prompt,
      median_chunk: median_chunk,
      ...(this.chatStatus !== 'SM' && { response_type: responseType }),
      previous_chat_history_id: previousID,
      uploaded_doc_name: fileName,
      total_tokens_utilized: total_tokens_utilized,
      total_cost_utilized: total_cost_utilized,
      utilization_token_json: utilization_token_json,
      chunk_validation_details: chunk_validation_details,
      top_chunks_used: top_chunks_used,
      dedup_audit_entries: dedup_audit_entries
    }
    this.sendChatResponseSubscription = this.ChatService.sendChatResponse(requestPayload, this.chatStatus).subscribe((res: any) => {
      this.previousHistoryId = res.id;
      this.chatConversation[this.chatConversation.length - 1]["chat_conversation_id"] = res.id;
      this.chatConversation[this.chatConversation.length - 1]["likedislike"] = "Empty";
      this.chatConversation[this.chatConversation.length - 1]["regenerate"] = "show";
      this.refreshHistory();
    });

  }
  handleColumnClick(columnText: string) {
    this.promptText = columnText;
    this.frmStt = false;
    this.checkTextResponse();
  }

  refreshHistory() {
    const options = {
      NC: 'Chat',
      SM: 'Summarizer' // Todo: Need to change from "Summarizer1" to "Summarizer" once history impelemented
    }
    const subType = options[this.chatStatus] || 'Chat';
    this.intService.refreshHistoryHandler({ refreshMenu: 'Chat', subType: subType });
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.streamSubscription) {
      this.streamSubscription.unsubscribe();
    }
    if (this.sseStreamSubscription) {
      this.sseStreamSubscription.unsubscribe();
    }
    if (this.loadHistoryDetailsSubscription) {
      this.loadHistoryDetailsSubscription.unsubscribe();
    }
    if (this.trendingTopicsSubscription) {
      this.trendingTopicsSubscription.unsubscribe();
    }
    if (this.summaraizerSubscription) {
      this.summaraizerSubscription.unsubscribe();
    }
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
    this.streamImageObjectUrls.forEach((url) => URL.revokeObjectURL(url));
    this.streamImageObjectUrls = [];
  }

  openAbiochatdialog(chatArrIndex, fileName?, page_numbers?, durations?) {
    /** Check token expiry and refresh if needed */
    if (this.checktokenExpiry()) {
      this.newAuthService.handleSessionExpiry();
      /* this.regenerateToken();
      setTimeout(() => {
        this.openAbiochatdialog(chatArrIndex, fileName, page_numbers);
      }, 10); */
      return;
    }
    let chatValues = this.chatConversation[chatArrIndex];
    const dialogData = {
      page_numbers: page_numbers,
      chatStatus: this.chatStatus,
      chatValues: chatValues,
      fileName: fileName,
      durations: durations
    };
    this.dialog.open(AbiochatReferenceDialogComponent, {
      width: '680px',
      // panelClass: "score-dialogbox",
      data: dialogData
    });
  }
  stopWritingClick() {
    const wasStreaming = this.streamingResponseOn || this.waitingForResponse;
    this.showSpinner = false;
    this.streamingResponseOn = false;
    this.stopWriting = false;
    this.showStreamProgress = false;
    this.waitingForResponse = false;
    if (this.streamSubscription) {
      this.streamSubscription.unsubscribe();
    }
    if (this.sseStreamSubscription) {
      this.sseStreamSubscription.unsubscribe();
    }
    if (this.ChatService.streamedDataSubscription) {
      this.ChatService.streamedDataSubscription.unsubscribe();
    }
    if (this.summarizerQandASubscription) {
      this.summarizerQandASubscription.unsubscribe();
    }
    if (this.CustomizeDetailsSubscription) {
      //this.CustomizeDetailsSubscription.unsubscribe();    removed this as it giving problem while swithcing platfrom
    }
    const lastResponse = this.chatConversation[this.chatConversation.length - 1]?.response || "No response";
    const requestTime = this.requestStartTime
    const responseTime = this.responseTime
    const foundationModel = this.chatConversation[this.chatConversation.length - 1]?.foundationModel;
    const prompt = this.chatConversationLastUserRequest;
    if (wasStreaming && this.chatConversation.length) {
      this.saveChatResponse(requestTime, responseTime, foundationModel, prompt);
      this.chatConversation[this.chatConversation.length - 1]["likedislike"] = "Empty";
      this.chatConversation[this.chatConversation.length - 1]["regenerate"] = "show";
      this.chatConversationLastResponseIndex = this.chatConversation.length - 1;
    }
  }

  trackBy(index: number, item: any) {
    return item.id;
  }

  playGround() {
    this.isPlayGround = true;
    this.isPublicKnowledge = false
    this.getTextResponse(this.chatConversationLastUserRequest, false, false);
  }
  playGroundB() {
    this.isPlayGroundB = true;
    this.isPlayGround = false;
    this.isPublicKnowledge = false;
    this.getTextResponse(this.chatConversationLastUserRequest, false, false);
  }
  questions() {
    this.router.navigate(['/app-question-list'], { skipLocationChange: true });
  }
  getFormattedDate(date) {
    const selectedDate = new Date(date);
    const yyyy = selectedDate.getFullYear();
    let mm: any = selectedDate.getMonth() + 1; // Months start at 0!
    let dd: any = selectedDate.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    if (!this.isFileUplaodEnabled) return;
    this.isDragOver = true;
  }
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    if (!this.isFileUplaodEnabled) return;
    this.isDragOver = false;
  }
  onDrop(event: DragEvent) {
    event.preventDefault();
    if (!this.isFileUplaodEnabled) return;
    this.isDragOver = false;
    const dt = event.dataTransfer;
    if (!dt?.files?.length) return;

    const file = dt.files[0];
    this.selectFileForPrompt(file);

  }
  private generateFileHtml(fileInput: File | string): string {
    const fileName = typeof fileInput === 'string' ? fileInput : fileInput.name;

    const safeName = this.escapeHtml(fileName);
    const truncatedName = this.escapeHtml(this.truncateName(fileName));

    return `
    <div class="file-attachment-display">
      <span class="file-name" title="${safeName}" data-file-name="${safeName}">${truncatedName}</span>
      <span class="material-icons file-icon" aria-hidden="true">description</span>
    </div>
  `;
  }

  private escapeHtml(value: string): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  truncateName(fileName: string, maxLength: number = 30): string {
    if (fileName.length <= maxLength) {
      return fileName;
    }

    const extension = fileName.slice(fileName.lastIndexOf('.'));
    const nameWithoutExt = fileName.slice(0, fileName.lastIndexOf('.'));
    const availableLength = maxLength - extension.length - 3;

    return nameWithoutExt.slice(0, availableLength) + '...' + extension;
  }
  downloadUploadedFile(uploadedFileHtml: string, event: Event) {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    const fileName = this.extractFileNameFromHtml(uploadedFileHtml);

    if (!fileName) {
      this.toastr.error('Could not determine file name.');
      return;
    }

    this.showSpinner = true;
    this.tts.resetAudio();

    if (this.pdfClientSubscription) {
      this.pdfClientSubscription.unsubscribe();
    }

    const JWT_token = localStorage.getItem('bearer_token');
    const fileNameWithUserId = this.userId + '_' + fileName;
    const encodedFileName = encodeURIComponent(fileNameWithUserId);
    const docUrl = `${this.apimUrl}/ai-advisor-storage/getblobmetadata?blobContainer=summary-docs&fileNameWithExtension=${encodedFileName}&Authorization=${JWT_token}`;


    const mimeType = this.getDocumentType(fileName);
    const isVideo = this.isVideoFileName(fileName) || (mimeType?.startsWith('video/') ?? false);
    const isAudio = this.isAudioFileName(fileName) || (mimeType?.startsWith('audio/') ?? false);

    if (isVideo) {
      this.openVideoInViewer(docUrl, undefined, undefined, fileName);
      this.showSpinner = false;
    } else if (isAudio) {
      this.openAudioInViewer(docUrl, undefined, undefined, fileName);
      this.showSpinner = false;
    } else {
      this.showSpinner = false;
      this.openSecureDocViewer(docUrl, 1, fileName, false, this.isImageFileName(fileName) ? 'image' : 'pdf');
    }
  }

  private extractFileNameFromHtml(html: string): string {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fileNameSpan = doc.querySelector('.file-name');
      if (fileNameSpan) {
        // Visible text is truncated for layout, so the untruncated name is read from the element instead.
        const rawName = fileNameSpan.getAttribute('data-file-name')
          ?? fileNameSpan.getAttribute('title')
          ?? fileNameSpan.textContent
          ?? '';
        let cleanName = rawName.trim();
        if (!cleanName) {
          return '';
        }
        const parts = cleanName.split('_');
        if (parts.length > 1 && !isNaN(Number(parts[0]))) {
          cleanName = parts.slice(1).join('_');
        }
        return cleanName;
      }
    } catch (e) {
      console.warn('Error extracting file name from HTML:', e);
    }
    return '';
  }

  shouldHighlightMessage(item: any, index: number): boolean {
    if (!this.highlightUserQuery || !item.response) {
      return false;
    }
    if (item.person === 'CS') {
      return item.response.toLowerCase().includes(this.highlightUserQuery.toLowerCase());
    }
    if (item.person === 'fieldRep' && index > 0) {
      const previousItem = this.chatConversation[index - 1];
      if (previousItem && previousItem.person === 'CS' && previousItem.response) {
        return previousItem.response.toLowerCase().includes(this.highlightUserQuery.toLowerCase());
      }
    }
    return false;
  }

   private extractInternalImageEntries(source: any): StreamImageEntry[] {
    const entries: StreamImageEntry[] = [];

    if (Array.isArray(source)) {
      source.forEach((item) => {
        if (!item || typeof item !== 'object') {
          return;
        }

        if (typeof item.image_path === 'string') {
          entries.push({
            path: item.image_path,
            description: typeof item.image_desc === 'string' ? item.image_desc : '',
            fileName: this.readImageReferenceFileName(item),
            pageNumber: this.readImageReferencePageNumber(item)
          });
          return;
        }

        const kvPairs = Object.entries(item);
        if (kvPairs.length === 1) {
          const [path, description] = kvPairs[0];
          entries.push({
            path,
            description: typeof description === 'string' ? description : ''
          });
        }
      });

      return this.deduplicateInternalImageEntries(entries);
    }

    if (source && typeof source === 'object') {
      if (typeof source.image_path === 'string') {
        return this.deduplicateInternalImageEntries([{
          path: source.image_path,
          description: typeof source.image_desc === 'string' ? source.image_desc : '',
          fileName: this.readImageReferenceFileName(source),
          pageNumber: this.readImageReferencePageNumber(source)
        }]);
      }

      return this.deduplicateInternalImageEntries(
        Object.entries(source).map(([path, description]) => ({
          path,
          description: typeof description === 'string' ? description : ''
        }))
      );
    }

    if (typeof source === 'string') {
      return this.deduplicateInternalImageEntries(this.extractInternalImageEntriesFromText(source));
    }

    return [];
  }

  // JHUD-5267: the stream payload spells the source document key differently across labels.
  private readImageReferenceFileName(item: any): string {
    const raw = item?.filename ?? item?.file_name ?? item?.image_file_name ?? item?.doc_name ?? '';
    return String(raw || '').trim();
  }

  private readImageReferencePageNumber(item: any): number | undefined {
    return this.toImageReferencePageNumber(item?.page_number ?? item?.page_no ?? item?.image_page_number);
  }

  private toImageReferencePageNumber(value: any): number | undefined {
    if (Array.isArray(value)) {
      return this.toImageReferencePageNumber(value[0]);
    }
    if (value === null || value === undefined || String(value).trim() === '') {
      return undefined;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
  }

  private extractInternalImageEntriesFromText(text: string): StreamImageEntry[] {
    const entries: StreamImageEntry[] = [];
    const rawText = String(text || '');

    const markdownImagePattern = /!\[[^\]]*\]\(([^)\s]+)\)/g;
    let markdownMatch: RegExpExecArray | null;
    while ((markdownMatch = markdownImagePattern.exec(rawText)) !== null) {
      const path = (markdownMatch[1] || '').trim();
      if (path) {
        entries.push({ path });
      }
    }

    const backtickPattern = /`([^`]+)`/g;
    let backtickMatch: RegExpExecArray | null;
    while ((backtickMatch = backtickPattern.exec(rawText)) !== null) {
      const path = (backtickMatch[1] || '').trim();
      if (path) {
        entries.push({ path });
      }
    }

    const rawPathPattern = /(summary-images\/[A-Za-z0-9._-]+\.(png|jpg|jpeg|webp|gif))/gi;
    let rawPathMatch: RegExpExecArray | null;
    while ((rawPathMatch = rawPathPattern.exec(rawText)) !== null) {
      const path = (rawPathMatch[1] || '').trim();
      if (path) {
        entries.push({ path });
      }
    }

    return entries;
  }

  private deduplicateInternalImageEntries(entries: StreamImageEntry[]): StreamImageEntry[] {
    const uniqueEntries = new Map<string, StreamImageEntry>();

    entries.forEach((entry) => {
      const normalizedPath = this.normalizeStreamImagePath(entry.path);
      if (!normalizedPath) {
        return;
      }

      const existing = uniqueEntries.get(normalizedPath);
      uniqueEntries.set(normalizedPath, {
        path: normalizedPath,
        description: entry.description || existing?.description || '',
        fileName: entry.fileName || existing?.fileName || '',
        pageNumber: entry.pageNumber ?? existing?.pageNumber
      });
    });

    return Array.from(uniqueEntries.values());
  }

  private normalizePersistedImageItems(source: any): PersistedImageItem[] {
    if (!Array.isArray(source)) {
      return [];
    }

    const entries: StreamImageEntry[] = source.map((item: any) => ({
      path: this.normalizeStreamImagePath(item?.image_path || item?.path || ''),
      description: String(item?.image_desc || item?.description || '').trim(),
      fileName: this.readImageReferenceFileName(item),
      pageNumber: this.readImageReferencePageNumber(item)
    }));

    return this.deduplicateInternalImageEntries(entries).map((entry) => ({
      image_path: entry.path,
      image_desc: String(entry.description || '').trim(),
      filename: String(entry.fileName || '').trim(),
      page_number: entry.pageNumber
    }));
  }

  private parsePersistedImageItems(source: any): PersistedImageItem[] {
    if (Array.isArray(source)) {
      return this.normalizePersistedImageItems(source);
    }

    if (typeof source === 'string' && source.trim() !== '') {
      try {
        const parsed = JSON.parse(source);
        return this.normalizePersistedImageItems(parsed);
      } catch {
        return [];
      }
    }

    return [];
  }

  private normalizeStreamImagePath(path: string): string {
    return String(path || '').replace(/^[\s`]+|[\s`]+$/g, '').trim();
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Builds the image metadata URL by reading the blob container and
  //   complete blob filename from the streamed image path.
  //
  // MODIFICATION HISTORY (latest first - keep ONLY the last 3):
  //   [JHUD-5269] 2026-09-29 16:18 | Venkatesan | Derived container and filename from image_path.
  // -----------------------------------------------------------------
  /**
   * Builds a metadata URL for a streamed or uploaded response image.
   * @param path Image path containing the blob container followed by the blob filename.
   * @returns Metadata endpoint URL for the requested image.
   */
  buildStreamImageMetadataUrl(path: string): string {
    const jwtToken = localStorage.getItem('bearer_token') || '';
    const normalizedPath = this.normalizeStreamImagePath(path).replace(/^\/+|\/+$/g, '');
    const pathSegments = normalizedPath.split('/').filter(Boolean);
    const hasContainerInPath = pathSegments.length > 1;
    const blobContainer = hasContainerInPath ? pathSegments[0] : 'summary-images';
    const blobFileName = hasContainerInPath ? pathSegments.slice(1).join('/') : normalizedPath;
    return `${this.apimUrl}/ai-advisor-storage/getblobmetadata?blobContainer=${encodeURIComponent(blobContainer)}&fileNameWithExtension=${encodeURIComponent(blobFileName)}&Authorization=${jwtToken}`;
  }

  private async resolveStreamImageUrl(path: string): Promise<string> {
    const metadataUrl = this.buildStreamImageMetadataUrl(path);
    const response = await fetch(metadataUrl, { credentials: 'omit' });
    if (!response.ok) {
      return metadataUrl;
    }

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (contentType.startsWith('image/')) {
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      this.streamImageObjectUrls.push(objectUrl);
      return objectUrl;
    }

    const payload = await response.json();
    return payload?.file_url || payload?.signedUrl || payload?.blobUrl || payload?.url || metadataUrl;
  }

  getSectionImages(section: any): StreamImageItem[] {
    if (!section?.images?.length) {
      return [];
    }

    if (section.showAllImages) {
      return section.images;
    }

    return this.getHiddenSectionImageCount(section) > 0
      ? section.images.slice(0, 3)
      : section.images.slice(0, this.maxInlineImages);
  }

  getHiddenSectionImageCount(section: any): number {
    if (!section?.images?.length) {
      return 0;
    }

    if (section.showAllImages) {
      return 0;
    }

    return Math.max(section.images.length - 3, 0);
  }

  shouldShowImageOverflowTile(section: any): boolean {
    return this.getHiddenSectionImageCount(section) > 0;
  }

  showAllSectionImages(section: any): void {
    section.showAllImages = true;
  }

  showLessSectionImages(section: any): void {
    section.showAllImages = false;
  }

  onImageContextMenu(event: MouseEvent): void {
    event?.preventDefault?.();
    event?.stopPropagation?.();
  }

  openImageDialog(src: string, imageDescription?: string): void {
    if (!src) {
      return;
    }
    this.openSecureDocViewer(src, 1, 'Image Viewer', false, 'image', true, true, imageDescription);
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Opens the reference document an image was extracted from, at the
  //   first page when the file name is clicked and at the referenced
  //   page when the page number is clicked.
  //
  // MODIFICATION HISTORY (latest first - keep ONLY the last 3):
  //   [JHUD-5267] 2026-09-30 11:20 | Venkatesan | Initial implementation.
  // -----------------------------------------------------------------
  /**
   * Opens the source document of an image in the secure document viewer.
   * @param chatArrIndex Index of the bot message the image belongs to.
   * @param image Image tile holding the reference file name and page number.
   * @param pageNumber Page to open; defaults to the first page.
   * @param event Optional click event to stop propagation on.
   */
  openImageReferenceDocument(chatArrIndex: number, image: StreamImageItem, pageNumber?: number, event?: MouseEvent): void {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    const rawFileName = String(image?.fileName || '').trim();
    if (!rawFileName) {
      return;
    }

    this.tts.resetAudio();
    sessionStorage.removeItem('showpad_doc_url');

    const location = this.findImageReferenceLocation(chatArrIndex, rawFileName);
    const docName = encodeURIComponent(this.replaceExtensionWithPdf(rawFileName));
    this.openBlobDocument(docName, location, this.toImageReferencePageNumber(pageNumber) ?? 1);
  }

  // JHUD-5267: images only carry a file name, so the blob folder is recovered from the response chunks.
  private findImageReferenceLocation(chatArrIndex: number, fileName: string): string {
    const target = this.getComparableDocName(fileName);
    if (!target) {
      return '';
    }

    const chunkContent = this.chatConversation?.[chatArrIndex]?.chunkContent ?? [];
    const match = chunkContent.find((chunk: any) =>
      this.getComparableDocName(chunk?.file_name) === target || this.getComparableDocName(chunk?.doc_name) === target);

    return match?.location ?? '';
  }

  private getComparableDocName(name: any): string {
    const baseName = String(name || '').split(/[?#]/)[0].split(/[\\/]/).pop() ?? '';
    return baseName.replace(/\.[a-z0-9]+$/i, '').trim().toLowerCase();
  }

  // -----------------------------------------------------------------
  // METHOD PURPOSE:
  //   Opens a streamed image in the secure viewer, passing along its
  //   reference document so the viewer can link back to file and page.
  //
  // MODIFICATION HISTORY (latest first - keep ONLY the last 3):
  //   [JHUD-5267] 2026-09-30 11:20 | Venkatesan | Initial implementation.
  // -----------------------------------------------------------------
  /**
   * Opens an image tile in the secure document viewer.
   * @param image Image tile to display.
   * @param chatArrIndex Index of the bot message the image belongs to.
   */
  openStreamImageDialog(image: StreamImageItem, chatArrIndex: number): void {
    const src = image?.src || this.buildStreamImageMetadataUrl(image?.path);
    if (!src) {
      return;
    }

    const referenceFileName = String(image?.fileName || '').trim();
    this.dialog.open(SecureDocViewerDialogComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'secure-doc-viewer-panel',
      autoFocus: false,
      disableClose: false,
      data: {
        docUrl: src,
        pageNumber: 1,
        title: 'Image Viewer',
        isExternalPage: false,
        mediaType: 'image',
        enableImageCopyActions: true,
        enableImageZoomActions: true,
        imageDescription: image?.description || '',
        referenceFileName: referenceFileName,
        referencePageNumber: image?.pageNumber,
        onOpenReference: referenceFileName
          ? (pageNumber?: number) => this.openImageReferenceDocument(chatArrIndex, image, pageNumber)
          : undefined
      } as SecureDocViewerData
    });
  }
}